import $hgUW1$bignumberjs from "bignumber.js";
import $hgUW1$pkcechallenge from "pkce-challenge";
import {SiweMessage as $hgUW1$SiweMessage} from "siwe";
import $hgUW1$react, {useState as $hgUW1$useState, useRef as $hgUW1$useRef, useEffect as $hgUW1$useEffect, useMemo as $hgUW1$useMemo, useLayoutEffect as $hgUW1$useLayoutEffect} from "react";
import {render as $hgUW1$render} from "react-dom";
import {setup as $hgUW1$setup, tw as $hgUW1$tw} from "twind";
import {createRoot as $hgUW1$createRoot} from "react-dom/client";
import {utils as $hgUW1$utils} from "ethers";
import {configureChains as $hgUW1$configureChains, createClient as $hgUW1$createClient} from "@wagmi/core";
import {mainnet as $hgUW1$mainnet, polygon as $hgUW1$polygon, optimism as $hgUW1$optimism, arbitrum as $hgUW1$arbitrum, avalanche as $hgUW1$avalanche} from "@wagmi/chains";
import {publicProvider as $hgUW1$publicProvider} from "@wagmi/core/providers/public";
import {MetaMaskConnector as $hgUW1$MetaMaskConnector} from "@wagmi/connectors/metaMask";
import {WalletConnectConnector as $hgUW1$WalletConnectConnector} from "@wagmi/connectors/walletConnect";
import {Buffer as $hgUW1$Buffer} from "buffer";
import {WalletReadyState as $hgUW1$WalletReadyState} from "@solana/wallet-adapter-base";
import $hgUW1$bs58 from "bs58";
import {authenticate as $hgUW1$authenticate, config as $hgUW1$config, unauthenticate as $hgUW1$unauthenticate, currentUser as $hgUW1$currentUser, discovery as $hgUW1$discovery} from "@onflow/fcl";
import {InjectedConnector as $hgUW1$InjectedConnector} from "@wagmi/connectors/injected";
import {CoinbaseWalletConnector as $hgUW1$CoinbaseWalletConnector} from "@wagmi/connectors/coinbaseWallet";
import {PhantomWalletAdapter as $hgUW1$PhantomWalletAdapter, SolflareWalletAdapter as $hgUW1$SolflareWalletAdapter, GlowWalletAdapter as $hgUW1$GlowWalletAdapter, BackpackWalletAdapter as $hgUW1$BackpackWalletAdapter} from "@solana/wallet-adapter-wallets";
import $hgUW1$qrcode from "qrcode";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}


var $81c1b644006d48ec$exports = {};

$parcel$export($81c1b644006d48ec$exports, "ChainTypes", () => $81c1b644006d48ec$export$976d254d94e5d55);
$parcel$export($81c1b644006d48ec$exports, "SigningMessageFormat", () => $81c1b644006d48ec$export$4ae89799dfbe2bff);
let $81c1b644006d48ec$export$976d254d94e5d55;
(function(ChainTypes) {
    ChainTypes["ETH"] = "ethereum";
    ChainTypes["SOL"] = "solana";
    ChainTypes["FLOW"] = "flow";
})($81c1b644006d48ec$export$976d254d94e5d55 || ($81c1b644006d48ec$export$976d254d94e5d55 = {}));
let $81c1b644006d48ec$export$4ae89799dfbe2bff;
(function(SigningMessageFormat) {
    SigningMessageFormat["SIMPLE"] = "simple";
    SigningMessageFormat["SIWE"] = "siwe";
})($81c1b644006d48ec$export$4ae89799dfbe2bff || ($81c1b644006d48ec$export$4ae89799dfbe2bff = {}));


var $4701dd2857dc78df$exports = {};

$parcel$defineInteropFlag($4701dd2857dc78df$exports);

$parcel$export($4701dd2857dc78df$exports, "DEFAULT_THEME", () => $4701dd2857dc78df$export$2faeed762aac6741);
$parcel$export($4701dd2857dc78df$exports, "API_VERSION", () => $4701dd2857dc78df$export$24a86ef7798177e4);
$parcel$export($4701dd2857dc78df$exports, "Picket", () => $4701dd2857dc78df$export$a9ae479f2e698b14);
$parcel$export($4701dd2857dc78df$exports, "default", () => $4701dd2857dc78df$export$2e2bcd8739ae039);






const $f54f8f1219a67c28$var$config = {
    darkMode: "class",
    important: true,
    // fake hash function to transform class names to keep them unique.
    // Prevents conflicts with other projects using tailwind or twind.
    hash: (name)=>`picket-tw-${name}`,
    theme: {
        borderRadius: {
            none: "0px",
            sm: "2px",
            DEFAULT: "4px",
            md: "6px",
            lg: "8px",
            xl: "12px",
            "2xl": "16px",
            "3xl": "24px",
            full: "9999px"
        },
        fontSize: {
            xs: [
                "12px",
                {
                    lineHeight: "16px"
                }
            ],
            sm: [
                "14px",
                {
                    lineHeight: "20px"
                }
            ],
            base: [
                "16px",
                {
                    lineHeight: "24px"
                }
            ],
            lg: [
                "18px",
                {
                    lineHeight: "28px"
                }
            ],
            xl: [
                "20px",
                {
                    lineHeight: "28px"
                }
            ],
            "2xl": [
                "24px",
                {
                    lineHeight: "32px"
                }
            ],
            "3xl": [
                "30px",
                {
                    lineHeight: "36px"
                }
            ],
            "4xl": [
                "36px",
                {
                    lineHeight: "40px"
                }
            ],
            "5xl": [
                "48px",
                {
                    lineHeight: "1"
                }
            ],
            "6xl": [
                "60px",
                {
                    lineHeight: "1"
                }
            ],
            "7xl": [
                "72px",
                {
                    lineHeight: "1"
                }
            ],
            "8xl": [
                "96px",
                {
                    lineHeight: "1"
                }
            ],
            "9xl": [
                "128px",
                {
                    lineHeight: "1"
                }
            ]
        },
        lineHeight: {
            3: "12px",
            4: "16px",
            5: "20px",
            6: "24px",
            7: "28px",
            8: "32px",
            9: "36px",
            10: "40px",
            none: "1",
            tight: "1.25",
            snug: "1.375",
            normal: "1.5",
            relaxed: "1.625",
            loose: "2"
        },
        minHeight: {
            0: "0px",
            full: "100%",
            screen: "100vh",
            min: "min-content",
            max: "max-content",
            fit: "fit-content"
        },
        minWidth: {
            0: "0px",
            full: "100%",
            min: "min-content",
            max: "max-content",
            fit: "fit-content"
        },
        spacing: {
            0: "0px",
            1: "4px",
            2: "8px",
            3: "12px",
            4: "16px",
            5: "20px",
            6: "24px",
            7: "28px",
            8: "32px",
            9: "36px",
            10: "40px",
            11: "44px",
            12: "48px",
            14: "56px",
            16: "64px",
            20: "80px",
            24: "96px",
            28: "112px",
            32: "128px",
            36: "144px",
            40: "160px",
            44: "176px",
            48: "192px",
            52: "208px",
            56: "224px",
            60: "240px",
            64: "256px",
            72: "288px",
            80: "320px",
            96: "384px",
            px: "1px",
            0.5: "2px",
            1.5: "6px",
            2.5: "10px",
            3.5: "14px"
        }
    }
};
var $f54f8f1219a67c28$export$2e2bcd8739ae039 = $f54f8f1219a67c28$var$config;





const $c45c1df1549392fa$export$ebdd5a8e5b1c2de5 = "_picket_connect_modal";
const $c45c1df1549392fa$export$c3ae8fcace251182 = "PICKET_CONNECT_OPEN";
const $c45c1df1549392fa$export$efac531f51245c0f = "PICKET_CONNECT_CLOSE";
const $c45c1df1549392fa$export$b710c88c1b6226c7 = "PICKET_CONNECT_SUCCESS";



const $39c3e322ce4471ca$var$NETWORK_DOESNT_EXIST_CODE = 4902;
const $39c3e322ce4471ca$export$5fef22ddd135361d = {
    ethereum: {
        chainName: "Ethereum",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://etherscan.io/"
        ]
    },
    polygon: {
        chainName: "Polygon",
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://polygonscan.com/"
        ]
    },
    optimism: {
        chainName: "Optimism",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://optimistic.etherscan.io/"
        ]
    },
    arbitrum: {
        chainName: "Arbitrum One",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://arbiscan.io/",
            "https://explorer.arbitrum.io/"
        ]
    },
    avalanche: {
        chainName: "Avalanche C-Chain",
        nativeCurrency: {
            name: "Avalanche",
            symbol: "AVAX",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://snowtrace.io/"
        ]
    }
};
const $39c3e322ce4471ca$export$84592b93abf12add = async ({ provider: provider , chainId: chainId , chainSlug: chainSlug , chainName: chainName , publicRPC: publicRPC  })=>{
    // compare current chainId with chainId to switch to
    const currentChainId = provider.chainId;
    if (typeof currentChainId === "string" && parseInt(currentChainId) === chainId) return;
    if (typeof currentChainId === "number" && currentChainId === chainId) return;
    // https://docs.metamask.io/guide/rpc-api.html#unrestricted-methods
    try {
        await provider?.request?.({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: (0, $hgUW1$utils).hexValue(chainId)
                }
            ]
        });
    } catch (err) {
        if (!err) return;
        if (typeof err === "object" && "code" in err && // @ts-ignore typecheck not working
        err.code === $39c3e322ce4471ca$var$NETWORK_DOESNT_EXIST_CODE) try {
            const params = $39c3e322ce4471ca$export$5fef22ddd135361d[chainSlug] || {};
            await provider?.request?.({
                method: "wallet_addEthereumChain",
                params: [
                    {
                        chainName: chainName,
                        chainId: (0, $hgUW1$utils).hexValue(chainId),
                        rpcUrls: [
                            publicRPC
                        ],
                        ...params
                    }
                ]
            });
        } catch (err) {
            console.log(err);
        }
        else // unknown error
        console.log(err);
    }
};


function $9f71b8ea7336133a$export$a11b0059900ceec8() {
    return typeof navigator !== "undefined" && /android|opera mini/i.test(navigator.userAgent);
}
function $9f71b8ea7336133a$export$ebe9999cfcbe2d25() {
    return typeof navigator !== "undefined" && /iPhone|iPod/i.test(navigator.userAgent);
}
function $9f71b8ea7336133a$export$208f8bf32e5bce0f() {
    return typeof navigator !== "undefined" && /iPad/i.test(navigator.userAgent);
}
function $9f71b8ea7336133a$export$fedb369cb70207f1() {
    return $9f71b8ea7336133a$export$ebe9999cfcbe2d25() || $9f71b8ea7336133a$export$208f8bf32e5bce0f();
}
function $9f71b8ea7336133a$export$d0a8044dce8ff2fc() {
    return $9f71b8ea7336133a$export$a11b0059900ceec8() || $9f71b8ea7336133a$export$ebe9999cfcbe2d25();
}
















var $69de93bc039ee573$require$Buffer = $hgUW1$Buffer;
const $69de93bc039ee573$export$10f67187c090302f = 28;
class $69de93bc039ee573$export$b39d0e3ec4c59911 {
    constructor({ id: id , name: name , connector: connector , color: color , Icon: Icon , getQRCodeURI: getQRCodeURI  }){
        this.connector = connector;
        this.id = id || connector.id;
        this.name = name || connector.name;
        this.color = color;
        this.Icon = Icon;
        this.qrCode = Boolean(getQRCodeURI);
        if (getQRCodeURI) this.getQRCodeURI = getQRCodeURI;
    }
    get ready() {
        return this.connector.ready;
    }
    // onConnecting exposes the start of the connecting event to the client
    // This is needed for getting the QR code URI. The WalletConnect session and it's associated QR code URI are only available
    // once only available once the connector starts "connecting"
    onConnecting(fn) {
        this.connector.on("message", ({ type: type  })=>type === "connecting" ? fn() : undefined);
    }
    // switch to onConnecting for QR Code models
    async connect({ chainId: chainId  } = {}) {
        const { account: account , provider: provider  } = await this.connector.connect({
            chainId: chainId
        });
        return {
            walletAddress: account,
            provider: provider
        };
    }
    async disconnect() {
        // clear wallet link session
        window.localStorage.removeItem("-walletlink:https://www.walletlink.org:version");
        window.localStorage.removeItem("-walletlink:https://www.walletlink.org:session:id");
        window.localStorage.removeItem("-walletlink:https://www.walletlink.org:session:secret");
        window.localStorage.removeItem("-walletlink:https://www.walletlink.org:session:linked");
        return this.connector.disconnect();
    }
    async signMessage(message) {
        const signer = await this.connector.getSigner();
        const signature = await signer.signMessage(message);
        return signature;
    }
    async qrCodeURI({ chainId: chainId  } = {}) {
        if (!this.getQRCodeURI) return "";
        const provider = await this.connector.getProvider({
            chainId: chainId
        });
        return await this.getQRCodeURI(provider);
    }
}
class $69de93bc039ee573$export$cc3eb5af8d3be041 {
    constructor({ adapter: adapter , color: color  }){
        this.adapter = adapter;
        this.id = adapter.name;
        this.name = adapter.name;
        this.Icon = ({ height: height = $69de93bc039ee573$export$10f67187c090302f , width: width = $69de93bc039ee573$export$10f67187c090302f  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("img", {
                className: (0, $hgUW1$tw)`rounded-md`,
                alt: adapter.name,
                src: adapter.icon,
                height: height,
                width: width
            });
        this.color = color;
    }
    // TODO: In future, we can use Ready state to show the "get wallet" vs "use wallet" based on what is installed on the user's device
    get ready() {
        return this.adapter.readyState === (0, $hgUW1$WalletReadyState).Installed || this.adapter.readyState === (0, $hgUW1$WalletReadyState).Loadable;
    }
    // for now, ignore chainId on Solana
    async connect({} = {}) {
        await this.adapter.connect();
        const { connected: connected , publicKey: publicKey  } = this.adapter;
        if (!connected || !publicKey) throw new Error(`failed to connect to ${this.name} wallet`);
        const walletAddress = publicKey.toString();
        return {
            walletAddress: walletAddress,
            provider: this.adapter
        };
    }
    async disconnect() {
        return this.adapter.disconnect();
    }
    async signMessage(message) {
        const messageBytes = new TextEncoder().encode(message);
        const signatureBytes = await this.adapter.signMessage(messageBytes);
        const signature = (0, $hgUW1$bs58).encode(signatureBytes);
        return signature;
    }
}
class $69de93bc039ee573$export$576302e02c218b1c {
    constructor({ service: service  }){
        this.service = service;
        const { name: name , color: color , icon: icon , address: address  } = service.provider;
        this.id = address;
        this.name = name;
        this.Icon = ({ height: height = $69de93bc039ee573$export$10f67187c090302f , width: width = $69de93bc039ee573$export$10f67187c090302f  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("img", {
                className: (0, $hgUW1$tw)`rounded-md`,
                alt: name,
                src: icon,
                height: height,
                width: width
            });
        this.color = color;
    }
    get ready() {
        return Boolean(this.service);
    }
    // for now, ignore chainId on Solana
    async connect({} = {}) {
        const { addr: addr  } = await $hgUW1$authenticate({
            service: this.service
        });
        // set this wallet as the chosen wallet for signature call
        $hgUW1$config().put("discovery.wallet", this.service.endpoint);
        return {
            walletAddress: addr,
            provider: this.service.provider
        };
    }
    async disconnect() {
        return $hgUW1$unauthenticate();
    }
    async signMessage(message) {
        const { signUserMessage: signUserMessage  } = await $hgUW1$currentUser();
        const messageHex = $69de93bc039ee573$require$Buffer.from(message).toString("hex");
        const [compositeSignature] = await signUserMessage(messageHex);
        const { signature: signature  } = compositeSignature;
        return signature;
    }
}



const $acc136706ebfaf11$var$allChains = [
    (0, $hgUW1$mainnet),
    (0, $hgUW1$polygon),
    (0, $hgUW1$optimism),
    (0, $hgUW1$arbitrum),
    (0, $hgUW1$avalanche)
];
const $acc136706ebfaf11$var$color = "#F6851B";
const $acc136706ebfaf11$var$Icon = ({ height: height = (0, $69de93bc039ee573$export$10f67187c090302f) , width: width = (0, $69de93bc039ee573$export$10f67187c090302f)  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        width: "28",
        height: "28",
        fill: "transparent"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M24.0891 3.1199L15.3446 9.61456L16.9617 5.7828L24.0891 3.1199Z",
        fill: "#E2761B",
        stroke: "#E2761B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M3.90207 3.1199L12.5763 9.67608L11.0383 5.7828L3.90207 3.1199Z",
        fill: "#E4761B",
        stroke: "#E4761B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M20.9429 18.1745L18.6139 21.7426L23.597 23.1136L25.0295 18.2536L20.9429 18.1745Z",
        fill: "#E4761B",
        stroke: "#E4761B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M2.97929 18.2536L4.40301 23.1136L9.38607 21.7426L7.05713 18.1745L2.97929 18.2536Z",
        fill: "#E4761B",
        stroke: "#E4761B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M9.10483 12.1456L7.71626 14.2461L12.6642 14.4658L12.4884 9.14877L9.10483 12.1456Z",
        fill: "#E4761B",
        stroke: "#E4761B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M18.8864 12.1456L15.4589 9.08725L15.3446 14.4658L20.2837 14.2461L18.8864 12.1456Z",
        fill: "#E4761B",
        stroke: "#E4761B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M9.38606 21.7426L12.3566 20.2925L9.79033 18.2888L9.38606 21.7426Z",
        fill: "#E4761B",
        stroke: "#E4761B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M15.6347 20.2925L18.6139 21.7426L18.2009 18.2888L15.6347 20.2925Z",
        fill: "#E4761B",
        stroke: "#E4761B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M18.6139 21.7426L15.6347 20.2925L15.8719 22.2348L15.8456 23.0521L18.6139 21.7426Z",
        fill: "#D7C1B3",
        stroke: "#D7C1B3",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M9.38606 21.7426L12.1544 23.0521L12.1368 22.2348L12.3566 20.2925L9.38606 21.7426Z",
        fill: "#D7C1B3",
        stroke: "#D7C1B3",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M12.1984 17.0056L9.72002 16.2762L11.4689 15.4765L12.1984 17.0056Z",
        fill: "#233447",
        stroke: "#233447",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M15.7928 17.0056L16.5223 15.4765L18.28 16.2762L15.7928 17.0056Z",
        fill: "#233447",
        stroke: "#233447",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M9.38606 21.7426L9.80791 18.1745L7.05712 18.2536L9.38606 21.7426Z",
        fill: "#CD6116",
        stroke: "#CD6116",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M18.1921 18.1745L18.6139 21.7426L20.9429 18.2536L18.1921 18.1745Z",
        fill: "#CD6116",
        stroke: "#CD6116",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M20.2837 14.2461L15.3446 14.4658L15.8016 17.0057L16.5311 15.4765L18.2888 16.2762L20.2837 14.2461Z",
        fill: "#CD6116",
        stroke: "#CD6116",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M9.72002 16.2762L11.4777 15.4765L12.1984 17.0057L12.6642 14.4658L7.71626 14.2461L9.72002 16.2762Z",
        fill: "#CD6116",
        stroke: "#CD6116",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M7.71626 14.2461L9.79033 18.2888L9.72002 16.2762L7.71626 14.2461Z",
        fill: "#E4751F",
        stroke: "#E4751F",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M18.2888 16.2762L18.2009 18.2888L20.2837 14.2461L18.2888 16.2762Z",
        fill: "#E4751F",
        stroke: "#E4751F",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M12.6642 14.4658L12.1984 17.0057L12.7784 20.0025L12.9102 16.0565L12.6642 14.4658Z",
        fill: "#E4751F",
        stroke: "#E4751F",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M15.3446 14.4658L15.1073 16.0477L15.2128 20.0025L15.8016 17.0057L15.3446 14.4658Z",
        fill: "#E4751F",
        stroke: "#E4751F",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M15.8016 17.0056L15.2128 20.0025L15.6347 20.2925L18.2009 18.2888L18.2888 16.2762L15.8016 17.0056Z",
        fill: "#F6851B",
        stroke: "#F6851B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M9.72002 16.2762L9.79033 18.2888L12.3566 20.2925L12.7784 20.0025L12.1984 17.0056L9.72002 16.2762Z",
        fill: "#F6851B",
        stroke: "#F6851B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M15.8456 23.0521L15.8719 22.2348L15.6522 22.0414H12.339L12.1368 22.2348L12.1544 23.0521L9.38606 21.7426L10.3528 22.5336L12.3126 23.8958H15.6786L17.6472 22.5336L18.6139 21.7426L15.8456 23.0521Z",
        fill: "#C0AD9E",
        stroke: "#C0AD9E",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M15.6347 20.2925L15.2128 20.0025H12.7784L12.3566 20.2925L12.1368 22.2348L12.339 22.0414H15.6522L15.8719 22.2348L15.6347 20.2925Z",
        fill: "#161616",
        stroke: "#161616",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M24.4583 10.0364L25.2053 6.45072L24.0891 3.1199L15.6347 9.39485L18.8864 12.1456L23.4827 13.4903L24.5022 12.3038L24.0628 11.9874L24.7658 11.3459L24.221 10.924L24.924 10.3879L24.4583 10.0364Z",
        fill: "#763D16",
        stroke: "#763D16",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M2.79472 6.45072L3.54174 10.0364L3.06717 10.3879L3.77024 10.924L3.23415 11.3459L3.93722 11.9874L3.4978 12.3038L4.50847 13.4903L9.10483 12.1456L12.3566 9.39485L3.90207 3.1199L2.79472 6.45072Z",
        fill: "#763D16",
        stroke: "#763D16",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M23.4827 13.4903L18.8864 12.1456L20.2837 14.2461L18.2009 18.2888L20.9429 18.2536H25.0295L23.4827 13.4903Z",
        fill: "#F6851B",
        stroke: "#F6851B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M9.10484 12.1456L4.50848 13.4903L2.97929 18.2536H7.05713L9.79033 18.2888L7.71626 14.2461L9.10484 12.1456Z",
        fill: "#F6851B",
        stroke: "#F6851B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M15.3446 14.4658L15.6347 9.39485L16.9705 5.7828H11.0383L12.3566 9.39485L12.6642 14.4658L12.7696 16.0653L12.7784 20.0025H15.2128L15.2304 16.0653L15.3446 14.4658Z",
        fill: "#F6851B",
        stroke: "#F6851B",
        strokeWidth: "0.0878845",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
const $acc136706ebfaf11$export$ec705e08fa602299 = (ethereum)=>{
    // Logic borrowed from wagmi's MetaMaskConnector
    // https://github.com/tmm/wagmi/blob/main/packages/core/src/connectors/metaMask.ts
    const isMetaMask = Boolean(ethereum.isMetaMask);
    if (!isMetaMask) return false;
    // Brave tries to make itself look like MetaMask
    // Could also try RPC `web3_clientVersion` if following is unreliable
    if (ethereum.isBraveWallet && !ethereum._events && !ethereum._state) return false;
    if (ethereum.isTokenPocket) return false;
    if (ethereum.isTokenary) return false;
    return true;
};
const $acc136706ebfaf11$var$isMetaMaskInjected = typeof window !== "undefined" && typeof window.ethereum !== "undefined" && $acc136706ebfaf11$export$ec705e08fa602299(window.ethereum);
const $acc136706ebfaf11$var$shouldUseWalletConnect = !$acc136706ebfaf11$var$isMetaMaskInjected;
const $acc136706ebfaf11$export$41bdf21621ec4e24 = ()=>new (0, $69de93bc039ee573$export$b39d0e3ec4c59911)({
        id: "metamask",
        name: "MetaMask",
        connector: $acc136706ebfaf11$var$shouldUseWalletConnect ? new (0, $hgUW1$WalletConnectConnector)({
            chains: $acc136706ebfaf11$var$allChains,
            options: {
                qrcode: false
            }
        }) : new (0, $hgUW1$MetaMaskConnector)({
            chains: $acc136706ebfaf11$var$allChains
        }),
        color: $acc136706ebfaf11$var$color,
        Icon: $acc136706ebfaf11$var$Icon,
        // show QR code if using wallet connect
        ...$acc136706ebfaf11$var$shouldUseWalletConnect ? {
            getQRCodeURI: async (provider)=>{
                const { uri: uri  } = provider.connector;
                const android = (0, $9f71b8ea7336133a$export$a11b0059900ceec8)();
                // android devices can use the default QR code
                if (android) return uri;
                // non-android, use the deep link
                return `https://metamask.app.link/wc?uri=${encodeURIComponent(uri)}`;
            }
        } : {}
    });
var $acc136706ebfaf11$export$2e2bcd8739ae039 = $acc136706ebfaf11$export$41bdf21621ec4e24;





const $13c0c3d38d2eede1$var$Icon = ({ height: height = (0, $69de93bc039ee573$export$10f67187c090302f) , width: width = (0, $69de93bc039ee573$export$10f67187c090302f)  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        stroke: "#5469d4",
        fill: "#5469d4",
        strokeWidth: "0",
        viewBox: "0 0 512 512",
        height: height,
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M95.5 104h320a87.73 87.73 0 0111.18.71 66 66 0 00-77.51-55.56L86 94.08h-.3a66 66 0 00-41.07 26.13A87.57 87.57 0 0195.5 104zm320 24h-320a64.07 64.07 0 00-64 64v192a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V192a64.07 64.07 0 00-64-64zM368 320a32 32 0 1132-32 32 32 0 01-32 32z"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M32 259.5V160c0-21.67 12-58 53.65-65.87C121 87.5 156 87.5 156 87.5s23 16 4 16-18.5 24.5 0 24.5 0 23.5 0 23.5L85.5 236z"
    }));
const $13c0c3d38d2eede1$export$41bdf21621ec4e24 = ()=>new (0, $69de93bc039ee573$export$b39d0e3ec4c59911)({
        connector: new (0, $hgUW1$InjectedConnector)(),
        color: "#5469d4",
        Icon: $13c0c3d38d2eede1$var$Icon
    });
var $13c0c3d38d2eede1$export$2e2bcd8739ae039 = $13c0c3d38d2eede1$export$41bdf21621ec4e24;








const $523cd398ac21f92d$var$allChains = [
    (0, $hgUW1$mainnet),
    (0, $hgUW1$polygon),
    (0, $hgUW1$optimism),
    (0, $hgUW1$arbitrum),
    (0, $hgUW1$avalanche)
];
const $523cd398ac21f92d$var$color = "#3B99FC";
const $523cd398ac21f92d$var$Icon = ({ height: height = (0, $69de93bc039ee573$export$10f67187c090302f) , width: width = (0, $69de93bc039ee573$export$10f67187c090302f)  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        className: (0, $hgUW1$tw)`rounded-lg`,
        height: height,
        width: width,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        height: 28,
        width: 28,
        fill: $523cd398ac21f92d$var$color
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M8.38969 10.3739C11.4882 7.27538 16.5118 7.27538 19.6103 10.3739L19.9832 10.7468C20.1382 10.9017 20.1382 11.1529 19.9832 11.3078L18.7076 12.5835C18.6301 12.6609 18.5045 12.6609 18.4271 12.5835L17.9139 12.0703C15.7523 9.9087 12.2477 9.9087 10.0861 12.0703L9.53655 12.6198C9.45909 12.6973 9.3335 12.6973 9.25604 12.6198L7.98039 11.3442C7.82547 11.1893 7.82547 10.9381 7.98039 10.7832L8.38969 10.3739ZM22.2485 13.012L23.3838 14.1474C23.5387 14.3023 23.5387 14.5535 23.3838 14.7084L18.2645 19.8277C18.1096 19.9827 17.8584 19.9827 17.7035 19.8277C17.7035 19.8277 17.7035 19.8277 17.7035 19.8277L14.0702 16.1944C14.0314 16.1557 13.9686 16.1557 13.9299 16.1944C13.9299 16.1944 13.9299 16.1944 13.9299 16.1944L10.2966 19.8277C10.1417 19.9827 9.89053 19.9827 9.73561 19.8278C9.7356 19.8278 9.7356 19.8277 9.7356 19.8277L4.61619 14.7083C4.46127 14.5534 4.46127 14.3022 4.61619 14.1473L5.75152 13.012C5.90645 12.857 6.15763 12.857 6.31255 13.012L9.94595 16.6454C9.98468 16.6841 10.0475 16.6841 10.0862 16.6454C10.0862 16.6454 10.0862 16.6454 10.0862 16.6454L13.7194 13.012C13.8743 12.857 14.1255 12.857 14.2805 13.012C14.2805 13.012 14.2805 13.012 14.2805 13.012L17.9139 16.6454C17.9526 16.6841 18.0154 16.6841 18.0541 16.6454L21.6874 13.012C21.8424 12.8571 22.0936 12.8571 22.2485 13.012Z",
        fill: "white"
    }));
const $523cd398ac21f92d$export$41bdf21621ec4e24 = ()=>{
    const iOS = (0, $9f71b8ea7336133a$export$fedb369cb70207f1)();
    return new (0, $69de93bc039ee573$export$b39d0e3ec4c59911)({
        connector: new (0, $hgUW1$WalletConnectConnector)({
            chains: $523cd398ac21f92d$var$allChains,
            options: {
                // on iOS, enable built-in WalletConnect selection modal
                qrcode: iOS
            }
        }),
        color: $523cd398ac21f92d$var$color,
        Icon: $523cd398ac21f92d$var$Icon,
        // on iOS, disable custom QR code
        ...iOS ? {} : {
            getQRCodeURI: async (provider)=>{
                return provider.connector.uri;
            }
        }
    });
};
var $523cd398ac21f92d$export$2e2bcd8739ae039 = $523cd398ac21f92d$export$41bdf21621ec4e24;








const $5df1d348dfa70efe$var$allChains = [
    (0, $hgUW1$mainnet),
    (0, $hgUW1$polygon),
    (0, $hgUW1$optimism),
    (0, $hgUW1$arbitrum),
    (0, $hgUW1$avalanche)
];
const $5df1d348dfa70efe$var$color = "#0C2F78";
const $5df1d348dfa70efe$var$Icon = ({ height: height = (0, $69de93bc039ee573$export$10f67187c090302f) , width: width = (0, $69de93bc039ee573$export$10f67187c090302f)  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        className: (0, $hgUW1$tw)`rounded-lg`,
        width: width,
        height: height,
        viewBox: "0 0 120 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        width: "120",
        height: "120",
        fill: "url(#paint0_linear_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M20 38H26C56.9279 38 82 63.0721 82 94V100H94C97.3137 100 100 97.3137 100 94C100 53.1309 66.8691 20 26 20C22.6863 20 20 22.6863 20 26V38Z",
        fill: "url(#paint1_radial_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M84 94H100C100 97.3137 97.3137 100 94 100H84V94Z",
        fill: "url(#paint2_linear_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M26 20L26 36H20L20 26C20 22.6863 22.6863 20 26 20Z",
        fill: "url(#paint3_linear_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M20 36H26C58.0325 36 84 61.9675 84 94V100H66V94C66 71.9086 48.0914 54 26 54H20V36Z",
        fill: "url(#paint4_radial_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M68 94H84V100H68V94Z",
        fill: "url(#paint5_linear_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M20 52L20 36L26 36L26 52H20Z",
        fill: "url(#paint6_linear_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M20 62C20 65.3137 22.6863 68 26 68C40.3594 68 52 79.6406 52 94C52 97.3137 54.6863 100 58 100H68V94C68 70.804 49.196 52 26 52H20V62Z",
        fill: "url(#paint7_radial_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M52 94H68V100H58C54.6863 100 52 97.3137 52 94Z",
        fill: "url(#paint8_radial_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M26 68C22.6863 68 20 65.3137 20 62L20 52L26 52L26 68Z",
        fill: "url(#paint9_radial_62_329)"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("defs", null, /*#__PURE__*/ (0, $hgUW1$react).createElement("linearGradient", {
        id: "paint0_linear_62_329",
        x1: "60",
        y1: "0",
        x2: "60",
        y2: "120",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        stopColor: "#174299"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#001E59"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("radialGradient", {
        id: "paint1_radial_62_329",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(26 94) rotate(-90) scale(74)"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "0.770277",
        stopColor: "#FF4000"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#8754C9"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("linearGradient", {
        id: "paint2_linear_62_329",
        x1: "83",
        y1: "97",
        x2: "100",
        y2: "97",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        stopColor: "#FF4000"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#8754C9"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("linearGradient", {
        id: "paint3_linear_62_329",
        x1: "23",
        y1: "20",
        x2: "23",
        y2: "37",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        stopColor: "#8754C9"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#FF4000"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("radialGradient", {
        id: "paint4_radial_62_329",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(26 94) rotate(-90) scale(58)"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "0.723929",
        stopColor: "#FFF700"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#FF9901"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("linearGradient", {
        id: "paint5_linear_62_329",
        x1: "68",
        y1: "97",
        x2: "84",
        y2: "97",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        stopColor: "#FFF700"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#FF9901"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("linearGradient", {
        id: "paint6_linear_62_329",
        x1: "23",
        y1: "52",
        x2: "23",
        y2: "36",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        stopColor: "#FFF700"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#FF9901"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("radialGradient", {
        id: "paint7_radial_62_329",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(26 94) rotate(-90) scale(42)"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "0.59513",
        stopColor: "#00AAFF"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#01DA40"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("radialGradient", {
        id: "paint8_radial_62_329",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(51 97) scale(17 45.3333)"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        stopColor: "#00AAFF"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#01DA40"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("radialGradient", {
        id: "paint9_radial_62_329",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(23 69) rotate(-90) scale(17 322.37)"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        stopColor: "#00AAFF"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("stop", {
        offset: "1",
        stopColor: "#01DA40"
    }))));
const $5df1d348dfa70efe$export$41bdf21621ec4e24 = ()=>new (0, $69de93bc039ee573$export$b39d0e3ec4c59911)({
        id: "rainbow",
        name: "Rainbow",
        connector: new (0, $hgUW1$WalletConnectConnector)({
            chains: $5df1d348dfa70efe$var$allChains,
            options: {
                qrcode: false
            }
        }),
        color: $5df1d348dfa70efe$var$color,
        Icon: $5df1d348dfa70efe$var$Icon,
        // on iOS, disable custom QR code
        getQRCodeURI: async (provider)=>{
            const { uri: uri  } = provider.connector;
            const android = (0, $9f71b8ea7336133a$export$a11b0059900ceec8)();
            const desktop = !(0, $9f71b8ea7336133a$export$d0a8044dce8ff2fc)();
            // android devices can use the default QR code
            if (android || desktop) return uri;
            // non-android, use the deep link
            return `https://rnbwapp.com/wc?uri=${encodeURIComponent(uri)}`;
        }
    });
var $5df1d348dfa70efe$export$2e2bcd8739ae039 = $5df1d348dfa70efe$export$41bdf21621ec4e24;








const $90f553ba7eaa0a52$var$allChains = [
    (0, $hgUW1$mainnet),
    (0, $hgUW1$polygon),
    (0, $hgUW1$optimism),
    (0, $hgUW1$arbitrum),
    (0, $hgUW1$avalanche)
];
const $90f553ba7eaa0a52$var$color = "#2C5FF6";
const $90f553ba7eaa0a52$var$Icon = ({ height: height = (0, $69de93bc039ee573$export$10f67187c090302f) , width: width = (0, $69de93bc039ee573$export$10f67187c090302f)  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        className: (0, $hgUW1$tw)`rounded-lg`,
        height: height,
        width: width,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        height: 28,
        width: 28,
        fill: $90f553ba7eaa0a52$var$color
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 23.8C19.4124 23.8 23.8 19.4124 23.8 14C23.8 8.58761 19.4124 4.2 14 4.2C8.58761 4.2 4.2 8.58761 4.2 14C4.2 19.4124 8.58761 23.8 14 23.8ZM11.55 10.8C11.1358 10.8 10.8 11.1358 10.8 11.55V16.45C10.8 16.8642 11.1358 17.2 11.55 17.2H16.45C16.8642 17.2 17.2 16.8642 17.2 16.45V11.55C17.2 11.1358 16.8642 10.8 16.45 10.8H11.55Z",
        fill: "white"
    }));
const $90f553ba7eaa0a52$export$41bdf21621ec4e24 = ()=>new (0, $69de93bc039ee573$export$b39d0e3ec4c59911)({
        connector: new (0, $hgUW1$CoinbaseWalletConnector)({
            chains: $90f553ba7eaa0a52$var$allChains,
            options: {
                appName: "Picket",
                // headlessMode => means we show our own QR code
                headlessMode: true
            }
        }),
        color: $90f553ba7eaa0a52$var$color,
        Icon: $90f553ba7eaa0a52$var$Icon,
        // on iOS, disable custom QR code because it will automatically deep link
        ...(0, $9f71b8ea7336133a$export$fedb369cb70207f1)() ? {} : {
            getQRCodeURI: async (provider)=>{
                return provider.qrUrl;
            }
        }
    });
var $90f553ba7eaa0a52$export$2e2bcd8739ae039 = $90f553ba7eaa0a52$export$41bdf21621ec4e24;









const $bfd6bdb31c3342b2$var$allChains = [
    (0, $hgUW1$mainnet),
    (0, $hgUW1$polygon),
    (0, $hgUW1$optimism),
    (0, $hgUW1$arbitrum),
    (0, $hgUW1$avalanche)
];
const $bfd6bdb31c3342b2$var$color = "#3375BB";
const $bfd6bdb31c3342b2$var$Icon = ({ height: height = (0, $69de93bc039ee573$export$10f67187c090302f) , width: width = (0, $69de93bc039ee573$export$10f67187c090302f)  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $hgUW1$tw)`rounded-lg`,
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        fill: "#fff",
        d: "M0 0h28v28H0z"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        fill: "#3375BB",
        fillRule: "evenodd",
        d: "M20.99 7.55a.92.92 0 0 1 .9.92 63.1 63.1 0 0 1-.33 6.19 12.91 12.91 0 0 1-.87 3.7 5.86 5.86 0 0 1-1.03 1.6 8.03 8.03 0 0 1-1.86 1.43l-.91.53c-.68.38-1.43.8-2.27 1.37-.3.2-.7.2-1.01 0-.86-.57-1.62-1-2.3-1.39l-.45-.25c-.8-.47-1.52-.9-2.15-1.55a5.5 5.5 0 0 1-1.08-1.54 10.7 10.7 0 0 1-.85-3.07c-.27-1.7-.4-3.93-.44-7.02a.91.91 0 0 1 .9-.92h.38a9.5 9.5 0 0 0 5.93-1.83.91.91 0 0 1 1.12 0 9.54 9.54 0 0 0 5.94 1.83h.38Zm-2.04 10.23c.29-.6.52-1.4.7-2.56.22-1.4.35-3.29.41-5.86-1.37-.04-3.71-.3-5.95-1.8a11.24 11.24 0 0 1-5.94 1.8c.05 2.13.15 3.78.3 5.08.18 1.48.42 2.48.74 3.19.2.46.43.8.7 1.1.36.4.82.73 1.45 1.1l.85.5c.56.31 1.2.67 1.9 1.12.7-.44 1.33-.8 1.87-1.11l.48-.27a7.94 7.94 0 0 0 1.76-1.24c.29-.3.52-.61.73-1.05Z",
        clipRule: "evenodd"
    }));
const $bfd6bdb31c3342b2$var$getQRCodeURI = async (provider)=>{
    const { uri: uri  } = provider.connector;
    const android = (0, $9f71b8ea7336133a$export$a11b0059900ceec8)();
    const desktop = !(0, $9f71b8ea7336133a$export$d0a8044dce8ff2fc)();
    // android devices can use the default QR code
    if (android || desktop) return uri;
    // non-android, use the deep link
    return `https://link.trustwallet.com/wc?uri=${encodeURIComponent(uri)}`;
};
const $bfd6bdb31c3342b2$export$41bdf21621ec4e24 = ()=>{
    const inAppBrowser = Boolean(typeof window !== "undefined" && window.ethereum?.isTrust);
    return new (0, $69de93bc039ee573$export$b39d0e3ec4c59911)({
        id: "trust",
        name: "Trust Wallet",
        // return injected connector if in app browser
        connector: inAppBrowser ? new (0, $hgUW1$InjectedConnector)({
            chains: $bfd6bdb31c3342b2$var$allChains
        }) : new (0, $hgUW1$WalletConnectConnector)({
            chains: $bfd6bdb31c3342b2$var$allChains,
            options: {
                qrcode: false
            }
        }),
        color: $bfd6bdb31c3342b2$var$color,
        Icon: $bfd6bdb31c3342b2$var$Icon,
        getQRCodeURI: inAppBrowser ? undefined : $bfd6bdb31c3342b2$var$getQRCodeURI
    });
};
var $bfd6bdb31c3342b2$export$2e2bcd8739ae039 = $bfd6bdb31c3342b2$export$41bdf21621ec4e24;








const $312bee862b7d3752$var$allChains = [
    (0, $hgUW1$mainnet),
    (0, $hgUW1$polygon),
    (0, $hgUW1$optimism),
    (0, $hgUW1$arbitrum),
    (0, $hgUW1$avalanche)
];
const $312bee862b7d3752$var$color = "#FF875B";
const $312bee862b7d3752$var$Icon = ({ height: height = (0, $69de93bc039ee573$export$10f67187c090302f) , width: width = (0, $69de93bc039ee573$export$10f67187c090302f)  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $hgUW1$tw)`rounded-lg`,
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        width: "28",
        height: "28",
        fill: "white"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M15.9033 7H11.8495C11.714 7 11.6055 7.10935 11.6026 7.24527C11.5207 11.0658 9.52894 14.6919 6.10076 17.2603C5.99192 17.3418 5.96712 17.495 6.04669 17.6053L8.41849 20.8966C8.49918 21.0086 8.6564 21.0338 8.76706 20.9515C10.9106 19.3561 12.6348 17.4314 13.8764 15.2981C15.118 17.4314 16.8423 19.3561 18.9858 20.9515C19.0964 21.0338 19.2536 21.0086 19.3344 20.8966L21.7062 17.6053C21.7857 17.495 21.7609 17.3418 21.6522 17.2603C18.2239 14.6919 16.2322 11.0658 16.1504 7.24527C16.1474 7.10935 16.0388 7 15.9033 7Z",
        fill: "#FF875B"
    }));
const $312bee862b7d3752$var$getQRCodeURI = async (provider)=>{
    const { uri: uri  } = provider.connector;
    const android = (0, $9f71b8ea7336133a$export$a11b0059900ceec8)();
    const desktop = !(0, $9f71b8ea7336133a$export$d0a8044dce8ff2fc)();
    // android devices can use the default QR code
    if (android || desktop) return uri;
    // non-android, use the deep link
    return `https://argent.link/app/wc?uri=${encodeURIComponent(uri)}`;
};
const $312bee862b7d3752$var$createWallet = ()=>new (0, $69de93bc039ee573$export$b39d0e3ec4c59911)({
        id: "argent",
        name: "Argent",
        connector: new (0, $hgUW1$WalletConnectConnector)({
            chains: $312bee862b7d3752$var$allChains,
            options: {
                qrcode: false
            }
        }),
        color: $312bee862b7d3752$var$color,
        Icon: $312bee862b7d3752$var$Icon,
        getQRCodeURI: $312bee862b7d3752$var$getQRCodeURI
    });
var $312bee862b7d3752$export$2e2bcd8739ae039 = $312bee862b7d3752$var$createWallet;


const $0fdb221228288199$var$allChains = [
    (0, $hgUW1$mainnet),
    (0, $hgUW1$polygon),
    (0, $hgUW1$optimism),
    (0, $hgUW1$arbitrum),
    (0, $hgUW1$avalanche)
];
const { provider: $0fdb221228288199$var$provider  } = (0, $hgUW1$configureChains)($0fdb221228288199$var$allChains, [
    (0, $hgUW1$publicProvider)()
]);
const $0fdb221228288199$var$needsInjectedWallet = ()=>typeof window !== "undefined" && window.ethereum && !(0, $acc136706ebfaf11$export$ec705e08fa602299)(window.ethereum) && // hide in Coinbase and Trust Wallet in-app browsers
    !window.ethereum.isCoinbaseWallet && !window.ethereum.isTrust;
// &&
// !window.ethereum.isBraveWallet;
// TODO: Consider adding brave native wallet support (for icon)
let $0fdb221228288199$var$walletsPromise = null;
const $0fdb221228288199$export$9a9fa7d4c9990968 = async ()=>{
    if ($0fdb221228288199$var$walletsPromise) return $0fdb221228288199$var$walletsPromise;
    $0fdb221228288199$var$walletsPromise = new Promise(async (resolve)=>{
        const walletCreators = $0fdb221228288199$var$needsInjectedWallet() ? [
            (0, $13c0c3d38d2eede1$export$2e2bcd8739ae039),
            (0, $acc136706ebfaf11$export$2e2bcd8739ae039),
            (0, $5df1d348dfa70efe$export$2e2bcd8739ae039),
            (0, $90f553ba7eaa0a52$export$2e2bcd8739ae039),
            (0, $523cd398ac21f92d$export$2e2bcd8739ae039),
            (0, $bfd6bdb31c3342b2$export$2e2bcd8739ae039),
            (0, $312bee862b7d3752$export$2e2bcd8739ae039)
        ] : [
            (0, $acc136706ebfaf11$export$2e2bcd8739ae039),
            (0, $5df1d348dfa70efe$export$2e2bcd8739ae039),
            (0, $90f553ba7eaa0a52$export$2e2bcd8739ae039),
            (0, $523cd398ac21f92d$export$2e2bcd8739ae039),
            (0, $bfd6bdb31c3342b2$export$2e2bcd8739ae039),
            (0, $312bee862b7d3752$export$2e2bcd8739ae039)
        ];
        const wallets = await Promise.all(walletCreators.map((wallet)=>wallet()));
        // this is never referenced but is needed!
        (0, $hgUW1$createClient)({
            connectors: wallets.map((wallet)=>wallet.connector),
            provider: $0fdb221228288199$var$provider
        });
        return resolve(wallets);
    });
    return $0fdb221228288199$var$walletsPromise;
};
var $0fdb221228288199$export$2e2bcd8739ae039 = $0fdb221228288199$export$9a9fa7d4c9990968;






const $f7808cfe629ea05b$var$color = "#5520f4";
const $f7808cfe629ea05b$export$41bdf21621ec4e24 = ()=>new (0, $69de93bc039ee573$export$cc3eb5af8d3be041)({
        // @ts-ignore There is an incorrect type issue on Parcel build
        adapter: new (0, $hgUW1$PhantomWalletAdapter)(),
        color: $f7808cfe629ea05b$var$color
    });
var $f7808cfe629ea05b$export$2e2bcd8739ae039 = $f7808cfe629ea05b$export$41bdf21621ec4e24;





const $7300722118d0663a$var$color = "#fb402e";
const $7300722118d0663a$export$41bdf21621ec4e24 = ()=>new (0, $69de93bc039ee573$export$cc3eb5af8d3be041)({
        adapter: new (0, $hgUW1$SolflareWalletAdapter)(),
        color: $7300722118d0663a$var$color
    });
var $7300722118d0663a$export$2e2bcd8739ae039 = $7300722118d0663a$export$41bdf21621ec4e24;





const $89fe6269b835c130$var$color = "#bb2dc7";
const $89fe6269b835c130$export$41bdf21621ec4e24 = ()=>new (0, $69de93bc039ee573$export$cc3eb5af8d3be041)({
        // Ignoring the type difference for now
        // GlowWalletAdapter sendTransaction is extends BaseMessageSignerWalletAdapter in an incompatible way
        // @ts-ignore
        adapter: new (0, $hgUW1$GlowWalletAdapter)(),
        color: $89fe6269b835c130$var$color
    });
var $89fe6269b835c130$export$2e2bcd8739ae039 = $89fe6269b835c130$export$41bdf21621ec4e24;





const $04365f2849aef5e2$var$color = "#e23f3f";
const $04365f2849aef5e2$export$41bdf21621ec4e24 = ()=>new (0, $69de93bc039ee573$export$cc3eb5af8d3be041)({
        // Ignoring the type difference for now
        // BackpackWalletAdapter sendTransaction is extends BaseMessageSignerWalletAdapter in an incompatible way
        // @ts-ignore
        adapter: new (0, $hgUW1$BackpackWalletAdapter)(),
        color: $04365f2849aef5e2$var$color
    });
var $04365f2849aef5e2$export$2e2bcd8739ae039 = $04365f2849aef5e2$export$41bdf21621ec4e24;


const $a1460b4d2edc55f8$export$cc4c1239387191ec = [
    (0, $f7808cfe629ea05b$export$2e2bcd8739ae039),
    (0, $7300722118d0663a$export$2e2bcd8739ae039),
    (0, $89fe6269b835c130$export$2e2bcd8739ae039),
    (0, $04365f2849aef5e2$export$2e2bcd8739ae039)
];
let $a1460b4d2edc55f8$var$walletsPromise = null;
const $a1460b4d2edc55f8$export$9a9fa7d4c9990968 = async ()=>{
    if (!$a1460b4d2edc55f8$var$walletsPromise) $a1460b4d2edc55f8$var$walletsPromise = Promise.all($a1460b4d2edc55f8$export$cc4c1239387191ec.map((wallet)=>wallet()));
    return $a1460b4d2edc55f8$var$walletsPromise;
};
var $a1460b4d2edc55f8$export$2e2bcd8739ae039 = $a1460b4d2edc55f8$export$9a9fa7d4c9990968;





$hgUW1$config({
    "flow.network": "mainnet",
    "accessNode.api": "https://rest-mainnet.onflow.org",
    "discovery.authn.endpoint": "https://fcl-discovery.onflow.org/api/authn",
    // Wallet list
    // https://github.com/onflow/fcl-discovery/blob/master/data/services.json
    // support dapper and ledger
    "discovery.authn.include": [
        "0xead892083b3e2c6c",
        "0xe5cd26afebe62781"
    ]
});
let $7675a526a7b09171$var$walletsPromise = null;
const $7675a526a7b09171$export$9a9fa7d4c9990968 = async ()=>{
    if ($7675a526a7b09171$var$walletsPromise) return $7675a526a7b09171$var$walletsPromise;
    $7675a526a7b09171$var$walletsPromise = new Promise((resolve)=>{
        $hgUW1$discovery.authn.subscribe((res)=>{
            if (!res || !Object.keys(res).length) return;
            const wallets = res.results.map((service)=>new (0, $69de93bc039ee573$export$576302e02c218b1c)({
                    service: service
                }));
            return resolve(wallets);
        });
    });
    return $7675a526a7b09171$var$walletsPromise;
};
var $7675a526a7b09171$export$2e2bcd8739ae039 = $7675a526a7b09171$export$9a9fa7d4c9990968;






const $49bb0344ce8b1459$export$2b96349243a56116 = ()=>{
    const [isMobile, setMobile] = (0, $hgUW1$useState)(false);
    (0, $hgUW1$useEffect)(()=>{
        setMobile($9f71b8ea7336133a$export$d0a8044dce8ff2fc());
    }, []);
    return isMobile;
};


const $f3e1fb0fbc54f4d7$var$NewWalletButton = ({ mobilePreferredWalletLink: mobilePreferredWalletLink , desktopPreferredWalletLink: desktopPreferredWalletLink  })=>{
    const isMobile = (0, $49bb0344ce8b1459$export$2b96349243a56116)();
    return /*#__PURE__*/ (0, $hgUW1$react).createElement("a", {
        href: isMobile ? mobilePreferredWalletLink : desktopPreferredWalletLink,
        target: "_blank",
        rel: "noreferrer",
        style: {
            outlineOffset: "4px"
        },
        className: (0, $hgUW1$tw)`w-full rounded-lg bg-white p-2.5 text-center text-sm font-semibold shadow hover:bg-gray-100 dark:bg-[#26293B] dark:text-white dark:hover:bg-[#181B2E] sm:text-base`
    }, "New Wallet");
};
var $f3e1fb0fbc54f4d7$export$2e2bcd8739ae039 = $f3e1fb0fbc54f4d7$var$NewWalletButton;




const $8c42fa10a91890af$var$PoweredByPicket = ()=>{
    return /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`w-full mt-8 text-center font-base text-sm text-gray-400`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("a", {
        style: {
            outlineOffset: "4px"
        },
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://picketapi.com"
    }, "Powered by Picket"));
};
var $8c42fa10a91890af$export$2e2bcd8739ae039 = $8c42fa10a91890af$var$PoweredByPicket;





const $30dda09b2ef840aa$var$SuccessScreen = ({ displayAddress: displayAddress , selectedWallet: selectedWallet , hasTokenOwnershipRequirements: hasTokenOwnershipRequirements = false  })=>{
    return /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $hgUW1$react).Fragment, null, /*#__PURE__*/ (0, $hgUW1$react).createElement("h1", {
        className: (0, $hgUW1$tw)`mb-6 break-words px-7  text-center text-xl font-semibold text-[#414552] dark:text-white`
    }, "Welcome ", displayAddress), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex min-h-[350px] flex-1 flex-col ${hasTokenOwnershipRequirements ? "space-y-4" : "space-y-0"} mt-0 mb-0`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        // default color to Picket purple
        className: (0, $hgUW1$tw)`h-full w-full pt-0 text-[${selectedWallet?.color || "#5469d4"}]`,
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex items-center ${hasTokenOwnershipRequirements ? "flex-row space-x-4" : "flex-col space-y-2 text-center"}`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`h-7 w-7`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement(selectedWallet.Icon, null)), /*#__PURE__*/ (0, $hgUW1$react).createElement("p", {
        className: (0, $hgUW1$tw)`font-base w-45 break-normal text-sm text-gray-400 sm:text-base ${hasTokenOwnershipRequirements ? "text-left" : "text-center"}`
    }, "You have successfully authenticated", selectedWallet && selectedWallet.name ? ` with ${selectedWallet.name}` : "")), hasTokenOwnershipRequirements && /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex flex-row items-center space-x-4`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`h-7 w-7 bg-[${selectedWallet.color}] flex items-center justify-center rounded-full`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        // scaled to wallet icon size (28/24 -> 1.166667)
        width: "18.67",
        height: "16.33",
        viewBox: "0 0 16 14",
        fill: "#FAFAFA",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M7.99961 0.997559C3.91897 0.997559 0.599609 3.24076 0.599609 5.99756V8.567C0.599609 9.47388 1.00148 10.322 1.70273 10.8932C2.79273 11.782 4.12593 12.4076 5.58593 12.7364C6.36094 12.9108 7.1703 13.0033 7.99969 13.0033C8.82908 13.0033 9.63905 12.9108 10.4135 12.7364C11.8728 12.4077 13.2059 11.7821 14.2967 10.8932C14.9979 10.322 15.3998 9.47386 15.3998 8.567V5.99756C15.3998 3.24076 12.0804 0.997559 7.99977 0.997559H7.99961ZM2.93273 10.7944C2.68023 10.6331 2.4371 10.46 2.20774 10.2725C1.69462 9.85436 1.39961 9.23249 1.39961 8.56689V8.25439C1.79023 8.77377 2.31086 9.24127 2.93273 9.63689V10.7944ZM5.26649 11.8319C4.73023 11.6806 4.21711 11.4844 3.73337 11.2462V10.0794C4.20649 10.3062 4.72087 10.4956 5.26649 10.6431V11.8319ZM7.59961 12.1944C7.07649 12.1744 6.56398 12.115 6.06649 12.02V10.8231C6.55961 10.9131 7.07212 10.9706 7.59961 10.99V12.1944ZM9.93273 12.02C9.43523 12.1156 8.92211 12.175 8.39961 12.1944V10.99C8.92711 10.9712 9.44023 10.9137 9.93273 10.8231V12.02ZM14.5996 8.56687C14.5996 9.2325 14.3046 9.85438 13.7915 10.2725C13.5621 10.46 13.319 10.6325 13.0665 10.7943V10.5975C13.0665 10.3768 12.8871 10.1975 12.6665 10.1975C12.4459 10.1975 12.2665 10.3768 12.2665 10.5975V11.2462C11.7827 11.485 11.269 11.6806 10.7334 11.8318V10.6425C12.4108 10.19 13.7871 9.33497 14.6003 8.25431L14.5996 8.56687ZM10.2652 9.9425C10.2558 9.94438 10.2465 9.94625 10.2371 9.94875C9.53833 10.1094 8.78459 10.1975 7.99965 10.1975C7.2147 10.1975 6.46152 10.1094 5.7622 9.94875C5.75283 9.94625 5.74345 9.94438 5.73408 9.9425C3.2072 9.35313 1.39968 7.80746 1.39968 5.99754C1.39968 3.68122 4.36032 1.79754 7.99968 1.79754C11.639 1.79754 14.5997 3.68122 14.5997 5.99754C14.5997 7.80746 12.7922 9.35322 10.2653 9.9425H10.2652Z"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M11.7779 5.23265C11.7141 5.00766 11.5154 4.83328 11.2479 4.7664L9.72097 4.38577L8.53534 3.50141C8.23971 3.28078 7.75971 3.28078 7.46409 3.50141L6.27846 4.38577L4.75096 4.7664C4.48345 4.83327 4.28532 5.00765 4.22158 5.23265C4.16533 5.43078 4.22158 5.64141 4.37221 5.7964L5.36971 6.82265L5.37846 7.61766C5.38096 7.79517 5.46346 7.95829 5.6122 8.07766C5.80784 8.23454 6.09908 8.29641 6.3722 8.23953L7.96033 7.90704C7.98471 7.90141 8.01408 7.90141 8.03971 7.90704L9.62783 8.23953C9.69534 8.25328 9.76346 8.26078 9.83096 8.26078C10.0385 8.26078 10.2403 8.19641 10.3878 8.07829C10.5366 7.95891 10.6191 7.79579 10.6216 7.61829L10.6303 6.82328L11.6278 5.79702C11.7785 5.64202 11.8347 5.43077 11.7778 5.23266L11.7779 5.23265ZM9.98777 6.33515C9.8884 6.43765 9.83215 6.56952 9.8309 6.7064L9.82277 7.46014C9.81277 7.45952 9.80215 7.45827 9.79152 7.45639L8.20402 7.1239C8.13714 7.11015 8.06839 7.10265 8.00028 7.10265C7.93152 7.10265 7.86277 7.10952 7.79653 7.1239L6.20903 7.45639C6.19778 7.45889 6.18778 7.46014 6.17715 7.46014L6.16903 6.70577C6.16715 6.5689 6.11153 6.43702 6.01215 6.33453L5.18402 5.48328L6.48278 5.15953C6.57903 5.13516 6.6659 5.09516 6.74028 5.03953L7.93841 4.14517C7.96528 4.13079 8.03528 4.13079 8.05716 4.14267L9.26028 5.04017C9.33403 5.09517 9.4209 5.13579 9.51778 5.15954L10.8153 5.48454L9.98777 6.33515Z"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M10.33 2.48209C10.1157 2.42772 9.89816 2.55772 9.8444 2.77209C9.79003 2.98646 9.92003 3.20397 10.1338 3.25773C12.0869 3.75147 13.3994 4.85273 13.3994 5.99773C13.3994 6.35273 13.2744 6.70648 13.0281 7.04835C12.7794 7.39334 12.42 7.71085 11.96 7.99272C11.7719 8.10772 11.7125 8.35459 11.8275 8.54272C11.9031 8.66584 12.0344 8.73397 12.1694 8.73397C12.2406 8.73397 12.3125 8.71522 12.3775 8.67522C12.9288 8.33771 13.3656 7.94834 13.6769 7.51646C14.0238 7.03522 14.1994 6.52459 14.1994 5.99771C14.1994 4.45646 12.6806 3.07643 10.3299 2.48203L10.33 2.48209Z"
    }))), /*#__PURE__*/ (0, $hgUW1$react).createElement("p", {
        className: (0, $hgUW1$tw)`font-base w-45 break-normal text-sm text-gray-400 sm:text-base`
    }, "Your wallet holds the necessary tokens"))), /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $8c42fa10a91890af$export$2e2bcd8739ae039), null));
};
var $30dda09b2ef840aa$export$2e2bcd8739ae039 = $30dda09b2ef840aa$var$SuccessScreen;





// TOOD: Distinguish between ERC20 and NFT, NFT SPL and fungible SPL
const $ff9871898d6c0351$var$getPurchaseLink = (chain, requirements)=>{
    // case 1 Solana
    // don't have a great way to surface the collection as of right now, so send to the marketplace
    if (chain === "solana") return "https://magiceden.io/";
    // EVM
    // case 2 assume EVM NFT (for now)
    const { contractAddress: contractAddress  } = requirements;
    if (chain === "ethereum") {
        if (!contractAddress) return "https://opensea.io/assets?search[chains][0]=ETHEREUM&search[resultModel]=ASSETS";
        return `https://opensea.io/assets?search[resultModel]=ASSETS&search[query]=${contractAddress}&search[chains][0]=ETHEREUM`;
    }
    if (chain === "polygon") {
        if (!contractAddress) return "https://opensea.io/assets?search[chains][0]=MATIC&search[resultModel]=ASSETS";
        return `https://opensea.io/assets?search[resultModel]=ASSETS&search[query]=${contractAddress}&search[chains][0]=MATIC`;
    }
    if (chain === "optimism") {
        if (!contractAddress) return "https://qx.app";
        return `https://qx.app/search?query=${contractAddress}`;
    }
    if (chain === "arbitrum") {
        if (!contractAddress) return "https://opensea.io/assets?search[chains][0]=ARBITRUM&search[resultModel]=ASSETS";
        return `https://opensea.io/assets?search[resultModel]=ASSETS&search[query]=${contractAddress}&search[chains][0]=ARBITRUM`;
    }
    if (chain === "avalanche") {
        if (!contractAddress) return "https://joepegs.com";
        return `https://joepegs.com/collections/${contractAddress}`;
    }
    // shouldn't get here but return opensea as default
    return "https://opensea.io";
};
const $ff9871898d6c0351$var$TokenGateFailureScreen = ({ chain: chain , displayAddress: displayAddress , selectedWallet: selectedWallet , requirements: requirements , back: back  })=>{
    return /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $hgUW1$react).Fragment, null, /*#__PURE__*/ (0, $hgUW1$react).createElement("h1", {
        className: (0, $hgUW1$tw)`mb-6 break-words px-7 text-center text-xl font-semibold text-[#414552] dark:text-white`
    }, "Almost There"), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex min-h-[350px] flex-1 flex-col space-y-4`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        width: "197",
        height: "187",
        viewBox: "0 0 197 187",
        className: (0, $hgUW1$tw)`text-[${selectedWallet.color}] my-8 self-center`,
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        y: "6.16943",
        width: "178.904",
        height: "178.904",
        rx: "89.4522",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M90.3038 51.7285C59.8853 51.7285 35.1416 68.4501 35.1416 89.0003V108.154C35.1416 114.914 38.1373 121.236 43.3646 125.494C51.4899 132.119 61.428 136.783 72.3114 139.234C78.0885 140.534 84.1218 141.224 90.3044 141.224C96.4869 141.224 102.525 140.534 108.297 139.234C119.176 136.784 129.113 132.12 137.244 125.494C142.471 121.236 145.467 114.914 145.467 108.154V89.0003C145.467 68.4501 120.723 51.7285 90.305 51.7285H90.3038ZM52.5335 124.757C50.6513 123.555 48.8389 122.265 47.1291 120.867C43.3042 117.75 41.1051 113.115 41.1051 108.153V105.823C44.0169 109.695 47.8978 113.18 52.5335 116.129V124.757ZM69.9301 132.491C65.9327 131.364 62.1077 129.901 58.5017 128.126V119.427C62.0285 121.119 65.8629 122.53 69.9301 123.63V132.491ZM87.322 135.193C83.4225 135.044 79.6021 134.602 75.8936 133.894V124.972C79.5695 125.643 83.39 126.071 87.322 126.216V135.193ZM104.714 133.894C101.005 134.606 97.1804 135.049 93.2855 135.193V126.216C97.2177 126.076 101.043 125.647 104.714 124.972V133.894ZM139.502 108.153C139.502 113.115 137.303 117.75 133.478 120.867C131.769 122.265 129.956 123.551 128.074 124.757V123.29C128.074 121.645 126.737 120.308 125.092 120.308C123.448 120.308 122.111 121.645 122.111 123.29V128.126C118.505 129.905 114.675 131.364 110.682 132.491V123.625C123.186 120.252 133.446 113.878 139.507 105.823L139.502 108.153ZM107.192 118.407C107.122 118.421 107.053 118.435 106.983 118.454C101.774 119.651 96.1553 120.308 90.304 120.308C84.4528 120.308 78.8383 119.651 73.6254 118.454C73.5555 118.435 73.4856 118.421 73.4157 118.407C54.5795 114.014 41.1056 102.492 41.1056 89.0001C41.1056 71.7335 63.1752 57.6919 90.3043 57.6919C117.433 57.6919 139.503 71.7335 139.503 89.0001C139.503 102.492 126.029 114.015 107.193 118.407H107.192Z",
        fill: "#FAFAFA"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M118.467 83.2975C117.992 81.6203 116.51 80.3204 114.516 79.8218L103.134 76.9845L94.2962 70.3921C92.0924 68.7475 88.5143 68.7475 86.3107 70.3921L77.4726 76.9845L66.086 79.8218C64.092 80.3203 62.6151 81.6202 62.1399 83.2975C61.7206 84.7744 62.1399 86.3445 63.2627 87.4998L70.6984 95.1499L70.7637 101.076C70.7823 102.399 71.3973 103.615 72.5061 104.505C73.9644 105.675 76.1355 106.136 78.1714 105.712L90.0098 103.233C90.1915 103.191 90.4105 103.191 90.6015 103.233L102.44 105.712C102.943 105.814 103.451 105.87 103.954 105.87C105.501 105.87 107.006 105.39 108.105 104.51C109.214 103.62 109.829 102.404 109.848 101.081L109.913 95.1546L117.349 87.5045C118.471 86.3491 118.891 84.7743 118.467 83.2975L118.467 83.2975ZM105.123 91.5159C104.382 92.2799 103.963 93.2629 103.954 94.2833L103.893 99.9019C103.819 99.8973 103.739 99.888 103.66 99.874L91.8264 97.3955C91.3279 97.293 90.8154 97.237 90.3076 97.237C89.7951 97.237 89.2826 97.2883 88.7888 97.3955L76.955 99.874C76.8711 99.8926 76.7966 99.9019 76.7174 99.9019L76.6568 94.2786C76.6429 93.2583 76.2282 92.2753 75.4874 91.5112L69.3143 85.1657L78.9956 82.7524C79.7131 82.5707 80.3607 82.2725 80.9151 81.8579L89.8464 75.191C90.0467 75.0838 90.5686 75.0838 90.7316 75.1723L99.7001 81.8626C100.25 82.2726 100.897 82.5755 101.62 82.7525L111.292 85.1751L105.123 91.5159Z",
        fill: "#FAFAFA"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M107.677 62.7943C106.079 62.389 104.458 63.3581 104.057 64.9561C103.652 66.5541 104.621 68.1754 106.214 68.5762C120.773 72.2567 130.557 80.4659 130.557 89.0011C130.557 91.6474 129.625 94.2844 127.79 96.8328C125.935 99.4045 123.256 101.771 119.827 103.872C118.425 104.73 117.982 106.57 118.84 107.972C119.404 108.89 120.382 109.398 121.388 109.398C121.919 109.398 122.455 109.258 122.94 108.96C127.049 106.444 130.306 103.542 132.626 100.322C135.211 96.7349 136.521 92.9285 136.521 89.001C136.521 77.512 125.199 67.2247 107.676 62.7939L107.677 62.7943Z",
        fill: "#FAFAFA"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        x: "133.253",
        width: "62.925",
        height: "62.925",
        rx: "31.4625",
        fill: "#F7F7F8"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M165.332 6.16943C158.461 6.16943 151.871 8.90005 147.011 13.7584C142.153 18.6187 139.422 25.2081 139.422 32.0797C139.422 38.9513 142.152 45.5412 147.011 50.401C151.871 55.2592 158.461 57.99 165.332 57.99C172.204 57.99 178.794 55.2594 183.653 50.401C188.512 45.5407 191.242 38.9513 191.242 32.0797C191.242 25.2081 188.512 18.6182 183.653 13.7584C178.793 8.90027 172.204 6.16943 165.332 6.16943ZM165.332 46.6543C164.023 46.6543 162.842 45.8657 162.34 44.6553C161.838 43.445 162.117 42.0512 163.042 41.1255C163.968 40.1999 165.362 39.9215 166.572 40.4234C167.782 40.9252 168.571 42.106 168.571 43.4155C168.571 45.2035 167.12 46.6543 165.332 46.6543ZM168.571 35.3185H162.093V17.5052H168.571V35.3185Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("p", {
        className: (0, $hgUW1$tw)`mb-2 text-center text-sm font-semibold text-gray-600 dark:text-white`
    }, "Your wallet ", displayAddress, " doesn't hold the necessary tokens"), /*#__PURE__*/ (0, $hgUW1$react).createElement("a", {
        href: $ff9871898d6c0351$var$getPurchaseLink(chain, requirements),
        target: "_blank",
        rel: "noreferrer",
        className: (0, $hgUW1$tw)`py-3 bg-[${selectedWallet.color}] rounded-lg text-center font-semibold text-white`
    }, "Buy Tokens"), /*#__PURE__*/ (0, $hgUW1$react).createElement("button", {
        className: (0, $hgUW1$tw)`rounded-lg bg-gray-300 py-3 text-center font-semibold text-gray-600`,
        onClick: back
    }, "Try Other Wallet")), /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $8c42fa10a91890af$export$2e2bcd8739ae039), null));
};
var $ff9871898d6c0351$export$2e2bcd8739ae039 = $ff9871898d6c0351$var$TokenGateFailureScreen;








// Adapted from https://github.com/rainbow-me/rainbowkit/blob/main/packages/rainbowkit/src/components/QRCode/QRCode.tsx
const $abf8a825e4188513$var$generateMatrix = (value, errorCorrectionLevel)=>{
    const arr = Array.prototype.slice.call((0, $hgUW1$qrcode).create(value, {
        errorCorrectionLevel: errorCorrectionLevel
    }).modules.data, 0);
    const sqrt = Math.sqrt(arr.length);
    return arr.reduce((rows, key, index)=>(index % sqrt === 0 ? rows.push([
            key
        ]) : rows[rows.length - 1].push(key)) && rows, []);
};
const $abf8a825e4188513$var$generateDots = ({ ecl: ecl , uri: uri , size: size , logoSize: logoSize , logoColor: logoColor , darkMode: darkMode  })=>{
    const dots = [];
    const matrix = $abf8a825e4188513$var$generateMatrix(uri, ecl);
    const cellSize = size / matrix.length;
    let qrList = [
        {
            x: 0,
            y: 0
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 0,
            y: 1
        }
    ];
    qrList.forEach(({ x: x , y: y  })=>{
        const x1 = (matrix.length - 7) * cellSize * x;
        const y1 = (matrix.length - 7) * cellSize * y;
        for(let i = 0; i < 3; i++)dots.push(/*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
            fill: darkMode ? i % 2 !== 0 ? "#26293B" : "white" : i % 2 !== 0 ? "white" : logoColor,
            height: cellSize * (7 - i * 2),
            key: `${i}-${x}-${y}`,
            rx: (i - 2) * -5 + (i === 0 ? 2 : 0),
            ry: (i - 2) * -5 + (i === 0 ? 2 : 0),
            width: cellSize * (7 - i * 2),
            x: x1 + cellSize * i,
            y: y1 + cellSize * i
        }));
    });
    const clearArenaSize = Math.floor((logoSize + 25) / cellSize);
    const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
    const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
    matrix.forEach((row, i)=>{
        row.forEach((_, j)=>{
            if (matrix[i][j]) {
                if (!(i < 7 && j < 7 || i > matrix.length - 8 && j < 7 || i < 7 && j > matrix.length - 8)) {
                    if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) dots.push(/*#__PURE__*/ (0, $hgUW1$react).createElement("circle", {
                        cx: i * cellSize + cellSize / 2,
                        cy: j * cellSize + cellSize / 2,
                        fill: darkMode ? "white" : "black",
                        key: `circle-${i}-${j}`,
                        r: cellSize / 3
                    }));
                }
            }
        });
    });
    return dots;
};
function $abf8a825e4188513$export$2e2bcd8739ae039({ ecl: ecl = "M" , logoColor: logoColor = "black" , logoMargin: logoMargin = 10 , logoSize: logoSize = 50 , logo: Logo , size: sizeProp = 300 , uri: uri , disabled: disabled = false , darkMode: darkMode = false  }) {
    const padding = "10";
    // calculate size of the QRCode
    const size = sizeProp - parseInt(padding, 10) * 1;
    // create dots for QR code
    const dots = (0, $hgUW1$useMemo)(()=>$abf8a825e4188513$var$generateDots({
            ecl: ecl,
            logoSize: logoSize,
            logoColor: logoColor,
            size: size,
            uri: uri,
            darkMode: darkMode
        }), [
        ecl,
        logoSize,
        size,
        uri
    ]);
    const logoWrapperSize = logoSize + logoMargin * 2;
    return /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`relative w-full h-full flex-1 flex items-center justify-center bg-white dark:bg-[#26293B] p-[${padding}px] rounded-xl`,
        style: {
            filter: disabled ? "blur(4px)" : "none"
        }
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex justify-center items-center`,
        style: {
            height: size,
            userSelect: "none",
            width: size
        }
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`absolute rounded-xl`,
        style: {
            height: logoSize,
            width: logoSize
        }
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement(Logo, {
        width: logoSize,
        height: logoSize
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        height: size,
        style: {
            all: "revert"
        },
        width: size
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("defs", null, /*#__PURE__*/ (0, $hgUW1$react).createElement("clipPath", {
        id: "clip-wrapper"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        height: logoWrapperSize,
        width: logoWrapperSize
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("clipPath", {
        id: "clip-logo"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        height: logoSize,
        width: logoSize
    }))), /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        fill: "transparent",
        height: size,
        width: size
    }), dots)));
}


const $60fec0881df8b1a4$var$getConnectMessage = (state, error)=>{
    if (state === "connect") return "Open your phone camera or wallet to scan this QR code.";
    if (state === "signature") return `We've connected to your wallet. Open it to sign the message and prove its you.`;
    if (state === "auth") return `We've received your signature! Hold tight while we validate it.`;
    if (error) return "There was an error connecting to your wallet.";
    return "Open your phone camera or wallet to scan this QR code.";
};
const $60fec0881df8b1a4$var$getWarningMessage = ({ wallet: wallet , state: state  })=>{
    const walletName = // special case for WalletConnect
    wallet?.name && wallet.name !== "WalletConnect" ? wallet.name : "your wallet";
    if (state === "connect") // TODO: Ask if having issues and try regenerate QR code
    return `Still waiting to connect. Scan the QR code with ${walletName} or your phone camera to connect.`;
    return `Still waiting for your signature. Open ${walletName} to approve the request.`;
};
const $60fec0881df8b1a4$var$QRCodeConnectScreen = ({ uri: uri , selectedWallet: selectedWallet , connectState: connectState , error: error , warning: warning , connect: connect , darkMode: darkMode  })=>{
    return /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $hgUW1$react).Fragment, null, /*#__PURE__*/ (0, $hgUW1$react).createElement("h1", {
        className: (0, $hgUW1$tw)`mb-6 break-words px-7 text-center text-xl font-semibold text-[#414552] dark:text-white`
    }, "Connect to ", selectedWallet.name), warning && !error && connectState !== "auth" && /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`absolute left-0 bottom-0 flex h-[120px] w-full flex-col rounded-b-xl bg-yellow-100 py-6 px-6 text-center text-sm text-yellow-700`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: "flex-1"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("p", null, $60fec0881df8b1a4$var$getWarningMessage({
        wallet: selectedWallet,
        state: connectState
    }))), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`mt-4 text-xs`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("p", null, connectState === "connect" ? "QR code not working?" : "Don't see the signing request?", " ", /*#__PURE__*/ (0, $hgUW1$react).createElement("button", {
        className: (0, $hgUW1$tw)`underline`,
        onClick: ()=>connect(selectedWallet)
    }, "Get a new one.")))), error && /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`absolute left-0 bottom-0 flex h-[120px] w-full flex-col rounded-b-xl bg-[#EE4870] py-6 px-6 text-center text-sm text-white`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: "flex-1 font-semibold"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("p", null, error)), selectedWallet && /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`mt-4 text-xs`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("p", null, "Get here by accident?", " ", /*#__PURE__*/ (0, $hgUW1$react).createElement("button", {
        className: (0, $hgUW1$tw)`underline`,
        onClick: ()=>connect(selectedWallet)
    }, "Try again.")))), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex min-h-[350px] flex-1 flex-col items-center space-y-4`
    }, uri ? /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $hgUW1$react).Fragment, null, /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $abf8a825e4188513$export$2e2bcd8739ae039), {
        uri: uri,
        logoColor: selectedWallet.color,
        logo: selectedWallet.Icon,
        disabled: connectState !== "connect",
        darkMode: darkMode
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`rounded-xl bg-white px-4 py-2 text-center text-sm font-semibold dark:bg-[#26293B] dark:text-white`
    }, $60fec0881df8b1a4$var$getConnectMessage(connectState, error)), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex flex-col items-center justify-center space-y-2 text-gray-500`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M17.8993 8.86737L16.4222 7.35189C16.176 7.09912 15.7796 7.09912 15.5333 7.35189C15.287 7.60465 15.287 8.01147 15.5333 8.26424L16.8325 9.59767V14.1172C16.8325 14.3277 16.6546 14.5103 16.4495 14.5103C16.2443 14.5103 16.0664 14.3277 16.0664 14.1172C16.0664 13.0502 15.2187 12.18 14.1791 12.18H14.1518V5.79359C14.1518 5.42843 13.8644 5.14771 13.5225 5.14771H6.69862C6.35673 5.14771 6.06932 5.42843 6.06932 5.79359V16.6437H5.72796C5.38607 16.6437 5.09866 16.9387 5.09866 17.2896C5.09866 17.6547 5.38607 17.9355 5.72796 17.9355H14.4804C14.8223 17.9355 15.1097 17.6547 15.1097 17.2896C15.1097 16.9387 14.8223 16.6437 14.4804 16.6437H14.1385V13.4712H14.1657C14.5076 13.4712 14.795 13.7662 14.795 14.1171C14.795 15.0437 15.5333 15.8015 16.4361 15.8015C17.3389 15.8015 18.0772 15.0437 18.0772 14.1171L18.0767 9.33051C18.0906 9.16219 18.0222 8.99386 17.8993 8.8672L17.8993 8.86737ZM10.1042 15.619C9.42041 15.619 8.85949 15.0433 8.85949 14.3415C8.85949 13.7801 9.6389 12.5311 9.96744 12.0399C10.0358 11.9417 10.1865 11.9417 10.2548 12.0399C10.5828 12.5311 11.3628 13.7665 11.3628 14.3415C11.3484 15.0433 10.788 15.619 10.1042 15.619H10.1042ZM12.8799 10.0046H7.3279V6.43968H12.8805L12.8799 10.0046Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "10",
        stroke: "currentColor",
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("rect", {
        x: "3.56757",
        y: "16.813",
        width: "20.0271",
        height: "1.46888",
        transform: "rotate(-35.9706 3.56757 16.813)",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`text-sm font-semibold`
    }, "Signing in is free. It costs no gas."))) : /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        role: "status",
        className: `flex flex-1 flex-col items-center justify-center`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        "aria-hidden": "true",
        className: (0, $hgUW1$tw)`mr-2 h-12 w-12 animate-spin text-gray-200`,
        style: {
            // tw doesn't support fill-* property yet
            fill: selectedWallet.color
        },
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
        fill: "currentFill"
    })), /*#__PURE__*/ (0, $hgUW1$react).createElement("span", {
        className: (0, $hgUW1$tw)`sr-only`
    }, "Loading..."))), /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $8c42fa10a91890af$export$2e2bcd8739ae039), null));
};
var $60fec0881df8b1a4$export$2e2bcd8739ae039 = $60fec0881df8b1a4$var$QRCodeConnectScreen;




const $9867507f00feaec3$var$getUserColorSchemePreference = ()=>window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
const $9867507f00feaec3$var$useUserColorSchemePreference = ()=>{
    const [colorSchemePreference, setColorSchemePreference] = (0, $hgUW1$useState)(()=>$9867507f00feaec3$var$getUserColorSchemePreference());
    (0, $hgUW1$useLayoutEffect)(()=>{
        const handler = ()=>setColorSchemePreference($9867507f00feaec3$var$getUserColorSchemePreference());
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", handler);
        return ()=>window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", handler);
    }, []);
    return colorSchemePreference;
};
const $9867507f00feaec3$export$4673cbff94e146e2 = (theme)=>{
    const colorSchemePreference = $9867507f00feaec3$var$useUserColorSchemePreference();
    const darkMode = theme === "dark" || theme === "auto" && colorSchemePreference === "dark";
    // add/remove tailwind class if any theme or preferences change
    (0, $hgUW1$useLayoutEffect)(()=>{
        const picketModalEl = document.getElementById((0, $c45c1df1549392fa$export$ebdd5a8e5b1c2de5));
        // should never happen!
        if (!picketModalEl) return;
        if (darkMode) picketModalEl.classList.add("dark");
        else picketModalEl.classList.remove("dark");
    }, [
        darkMode
    ]);
    return darkMode;
};



const $0aa6d5c30e08fb02$var$displayWalletAddress = (address)=>{
    return address.substring(0, 5) + "..." + address.substring(address.length - 3);
};
const $0aa6d5c30e08fb02$var$CONNECT_TIMEOUT_MS = 15000;
const $0aa6d5c30e08fb02$var$AUTO_CLOSE_MS = 3000;
const $0aa6d5c30e08fb02$var$WALLET_LOCAL_STORAGE_KEY = "_picket_wallet";
const $0aa6d5c30e08fb02$var$HAS_CONNECTED_SESSION_KEY = "_picket_has_connected";
const $0aa6d5c30e08fb02$var$METAMASK_DOWNLOAD_URL = "https://metamask.io/download/";
const $0aa6d5c30e08fb02$var$RAINBOW_DOWNLOAD_URL = "https://rainbow.me/";
const $0aa6d5c30e08fb02$var$PHANTOM_DOWNLOAD_URL = "https://phantom.app/download";
const $0aa6d5c30e08fb02$var$DAPPER_DOWNLOAD_URL = "https://www.meetdapper.com/";
const $0aa6d5c30e08fb02$var$NOT_ENOUGH_TOKENS_ERROR = "Your wallet doesn't hold the necessary tokens to login.";
const $0aa6d5c30e08fb02$var$defaultChainOptions = [
    {
        slug: "ethereum",
        name: "Ethereum",
        loadWallets: (0, $0fdb221228288199$export$2e2bcd8739ae039),
        desktopPreferredWalletLink: $0aa6d5c30e08fb02$var$METAMASK_DOWNLOAD_URL,
        mobilePreferredWalletLink: $0aa6d5c30e08fb02$var$RAINBOW_DOWNLOAD_URL
    },
    {
        slug: "solana",
        name: "Solana",
        loadWallets: (0, $a1460b4d2edc55f8$export$2e2bcd8739ae039),
        desktopPreferredWalletLink: $0aa6d5c30e08fb02$var$PHANTOM_DOWNLOAD_URL,
        mobilePreferredWalletLink: $0aa6d5c30e08fb02$var$PHANTOM_DOWNLOAD_URL
    },
    {
        slug: "flow",
        name: "Flow",
        loadWallets: (0, $7675a526a7b09171$export$2e2bcd8739ae039),
        desktopPreferredWalletLink: $0aa6d5c30e08fb02$var$DAPPER_DOWNLOAD_URL,
        mobilePreferredWalletLink: $0aa6d5c30e08fb02$var$DAPPER_DOWNLOAD_URL
    },
    {
        slug: "polygon",
        name: "Polygon",
        loadWallets: (0, $0fdb221228288199$export$2e2bcd8739ae039),
        desktopPreferredWalletLink: $0aa6d5c30e08fb02$var$METAMASK_DOWNLOAD_URL,
        mobilePreferredWalletLink: $0aa6d5c30e08fb02$var$RAINBOW_DOWNLOAD_URL
    },
    {
        slug: "optimism",
        name: "Optimism",
        loadWallets: (0, $0fdb221228288199$export$2e2bcd8739ae039),
        desktopPreferredWalletLink: $0aa6d5c30e08fb02$var$METAMASK_DOWNLOAD_URL,
        mobilePreferredWalletLink: $0aa6d5c30e08fb02$var$RAINBOW_DOWNLOAD_URL
    },
    {
        slug: "arbitrum",
        name: "Arbitrum",
        loadWallets: (0, $0fdb221228288199$export$2e2bcd8739ae039),
        desktopPreferredWalletLink: $0aa6d5c30e08fb02$var$METAMASK_DOWNLOAD_URL,
        mobilePreferredWalletLink: $0aa6d5c30e08fb02$var$RAINBOW_DOWNLOAD_URL
    },
    {
        slug: "avalanche",
        name: "Avalanche",
        loadWallets: (0, $0fdb221228288199$export$2e2bcd8739ae039),
        desktopPreferredWalletLink: $0aa6d5c30e08fb02$var$METAMASK_DOWNLOAD_URL,
        mobilePreferredWalletLink: $0aa6d5c30e08fb02$var$RAINBOW_DOWNLOAD_URL
    }
];
const $0aa6d5c30e08fb02$var$hasTokenOwnershipRequirements = (requirements)=>Boolean(requirements && (requirements.contractAddress || requirements.tokenIds && requirements.tokenIds?.length > 0 || requirements.collection));
// toTitleCase upperacses the first letter of a string
const $0aa6d5c30e08fb02$var$toTitleCase = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $0aa6d5c30e08fb02$var$connectStateMessage = {
    connect: "Connecting...",
    signature: "Requesting signature...",
    auth: "Authorizing..."
};
const $0aa6d5c30e08fb02$var$getWarningMessage = ({ wallet: wallet , state: state  })=>{
    const walletName = wallet?.name ?? "your wallet";
    if (state === "connect") return `Still waiting to connect to ${walletName}. Open ${walletName} to connect.`;
    return `Still waiting for your signature. Open ${walletName} to approve the request.`;
};
const $0aa6d5c30e08fb02$var$getErrorMessage = ({ err: err , wallet: wallet , walletAddress: walletAddress , state: state , selectedChain: selectedChain , requirements: requirements  })=>{
    const walletName = // special case for WalletConnect
    wallet?.name && wallet.name !== "WalletConnect" ? wallet.name : "your wallet";
    // generic errors
    if (err && typeof err === "object" && "msg" in err && // @ts-ignore TS isn't respecting "msg" in err
    typeof err.msg === "string") {
        // @ts-ignore TS isn't respecting "msg" in err
        if (err.msg.toLowerCase().includes("invalid project key")) return "Invalid API key. Copy your project's publishable key from your Picket dashboard: https://picketapi.com/dashboard";
        // @ts-ignore TS isn't respecting "msg" in err
        if (err.msg.toLowerCase().includes("invalid signature")) return "Signature expired. Please try again.";
    }
    // auth state specific errors
    if (state === "auth") {
        if (err && typeof err === "object" && "msg" in err && // @ts-ignore TS isn't respecting "msg" in err
        typeof err.msg === "string") {
            // @ts-ignore TS isn't respecting "msg" in err
            if (err.msg.toLowerCase().includes("invalid signature")) return "Signature expired. Please try again.";
            // @ts-ignore TS isn't respecting "msg" in err
            if (err.msg.toLowerCase().includes("token gating")) return `${$0aa6d5c30e08fb02$var$toTitleCase(selectedChain)} doesn't support token gating yet. Reach out to team@picketapi.com for more info.`;
            if (// @ts-ignore TS isn't respecting "msg" in err
            err.msg.toLowerCase().includes("any erc20, erc721, erc1155 tokens")) return `${requirements?.contractAddress ? $0aa6d5c30e08fb02$var$displayWalletAddress(requirements.contractAddress) : "The provided contract"} is not an ERC20, ERC721, or ERC1155 token. If this error persists, please contact your site administrator or team@picketapi.com.`;
            if (// @ts-ignore TS isn't respecting "msg" in err
            err.msg.toLowerCase().includes("allowedwallets must be an array")) return `Incorrect parameter type for "allowedWallets". If this error persists, please contact your site administrator or team@picketapi.com.`;
            if (// @ts-ignore TS isn't respecting "msg" in err
            err.msg.toLowerCase().includes("allowed wallet addresses")) return `${walletAddress ? $0aa6d5c30e08fb02$var$displayWalletAddress(walletAddress) : "Your wallet address"} is not on the allowed list of wallet addresses.`;
        }
        // assume token-gating error
        return $0aa6d5c30e08fb02$var$NOT_ENOUGH_TOKENS_ERROR;
    }
    // provider/wallet (Metamask, etc) errors
    // check for user rejected error cases
    if (err && typeof err === "object" && "message" in err && // @ts-ignore
    err.message.toLowerCase().includes("user rejected")) {
        if (state === "signature") return `The signature request was rejected.`;
        return `The request to connect to ${walletName} was rejected. Is your wallet unlocked?`;
    }
    // unknown error in signature state
    if (state === "signature") return `Failed to get your signature.`;
    // last resort
    return `Failed to connect to ${walletName}.`;
};
const $0aa6d5c30e08fb02$var$ConnectModal = ({ chain: chain , doAuth: doAuth = false , requirements: requirements , theme: theme = (0, $4701dd2857dc78df$export$2faeed762aac6741)  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(true);
    const [success, setSuccess] = (0, $hgUW1$useState)(false);
    const [warning, setWarning] = (0, $hgUW1$useState)(false);
    const warningTimeoutRef = (0, $hgUW1$useRef)(null);
    const [error, setError] = (0, $hgUW1$useState)("");
    const [connectState, setConnectState] = (0, $hgUW1$useState)(null);
    const [displayAddress, setDisplayAddress] = (0, $hgUW1$useState)();
    const [selectedWallet, setSelectedWallet] = (0, $hgUW1$useState)();
    const [chainOptions, setChainOptions] = (0, $hgUW1$useState)([]);
    const [selectedChainOption, setSelectedChainOption] = (0, $hgUW1$useState)();
    const [walletList, setWalletList] = (0, $hgUW1$useState)();
    const [qrCodeURI, setQRCodeURI] = (0, $hgUW1$useState)("");
    const selectedChain = selectedChainOption?.slug || "";
    const darkMode = (0, $9867507f00feaec3$export$4673cbff94e146e2)(theme);
    const switchChains = (chain)=>{
        const options = $0aa6d5c30e08fb02$var$defaultChainOptions.filter(({ slug: slug  })=>slug === chain)[0];
        // should never happen
        if (!options) return;
        setSelectedChainOption(options);
        options.loadWallets().then(setWalletList);
        // clear wallet
        setSelectedWallet(undefined);
    };
    (0, $hgUW1$useEffect)(()=>{
        if (!chain) {
            setChainOptions($0aa6d5c30e08fb02$var$defaultChainOptions);
            switchChains($0aa6d5c30e08fb02$var$defaultChainOptions[0].slug);
            return;
        }
        const fetchChainData = async ()=>{
            try {
                const { chainSlug: chainSlug , chainType: chainType , chainName: chainName  } = await window.picket.chainInfo(chain);
                const options = $0aa6d5c30e08fb02$var$defaultChainOptions.filter(({ slug: slug  })=>slug === chainSlug)[0];
                if (!options) throw new Error("Chain not found");
                switchChains(chainSlug);
                if (chainType === (0, $81c1b644006d48ec$export$976d254d94e5d55).SOL) {
                    setChainOptions([
                        {
                            slug: chainSlug,
                            name: chainName,
                            loadWallets: (0, $a1460b4d2edc55f8$export$2e2bcd8739ae039)
                        }
                    ]);
                    return;
                }
                if (chainType === (0, $81c1b644006d48ec$export$976d254d94e5d55).FLOW) setChainOptions([
                    {
                        slug: chainSlug,
                        name: chainName,
                        loadWallets: (0, $7675a526a7b09171$export$2e2bcd8739ae039)
                    }
                ]);
                // assume EVM
                setChainOptions([
                    {
                        slug: chainSlug,
                        name: chainName,
                        loadWallets: (0, $0fdb221228288199$export$2e2bcd8739ae039)
                    }
                ]);
                return;
            } catch (err) {
                console.error(err);
                setError(`Unsupported chain: ${chain}`);
            }
        };
        fetchChainData();
    }, []);
    const reset = ()=>{
        setIsOpen(true);
        setSuccess(false);
        setWarning(false);
        setError("");
        setSelectedWallet(undefined);
        setDisplayAddress("");
        setConnectState(null);
        warningTimeoutRef.current && clearTimeout(warningTimeoutRef.current);
    };
    (0, $hgUW1$useEffect)(()=>{
        const handleOpenEvent = (event)=>{
            if (!event.data?.type) return;
            if (event.data.type !== (0, $c45c1df1549392fa$export$c3ae8fcace251182)) return;
            // do nothing if already open
            if (isOpen) return;
            // reset state on open
            reset();
        };
        window.addEventListener("message", handleOpenEvent);
        return ()=>{
            window.removeEventListener("message", handleOpenEvent);
        };
    }, [
        isOpen
    ]);
    const close = ()=>{
        setIsOpen(false);
        window.postMessage({
            type: (0, $c45c1df1549392fa$export$efac531f51245c0f)
        });
    };
    // options are
    // error message function (error, state, selectedWallet)
    // useCallback
    const connect = async (wallet)=>{
        // HACK: Keep local state variable to make it available to
        // the catch clause for better error messages
        // This should be done with better error state w/ a function for displaying the message
        let state = "connect";
        // get last connected wallet
        // force the wallet to disconnect if we are connecting to a different wallet connect (aka QRCode) wallet
        // or if it has not connected in this tab session (force reconnect)
        const prevWallet = window.localStorage.getItem($0aa6d5c30e08fb02$var$WALLET_LOCAL_STORAGE_KEY);
        const hasConnected = window.sessionStorage.getItem($0aa6d5c30e08fb02$var$HAS_CONNECTED_SESSION_KEY);
        if (!hasConnected || prevWallet && prevWallet !== wallet.id && wallet.qrCode) try {
            // remove wallet connect session and cache
            await wallet.disconnect();
        } catch (err) {
            console.log("error on disconnect", err);
        }
        // save wallet to localStorage
        window.localStorage.setItem($0aa6d5c30e08fb02$var$WALLET_LOCAL_STORAGE_KEY, wallet.id);
        // do not disconnect while the session (tab) is active
        window.sessionStorage.setItem($0aa6d5c30e08fb02$var$HAS_CONNECTED_SESSION_KEY, "true");
        // clear error state
        setError("");
        // show warning after elapsed time
        setWarning(false);
        const timeoutID = setTimeout(()=>{
            setWarning(true);
            setError("");
        }, $0aa6d5c30e08fb02$var$CONNECT_TIMEOUT_MS);
        warningTimeoutRef.current = timeoutID;
        // keep in scope for error messages
        let walletAddress;
        try {
            setSelectedWallet(wallet);
            state = "connect";
            setConnectState(state);
            // use chain associated with the auth request
            // should be cached at this point
            const { chainSlug: chainSlug , chainId: chainId , chainType: chainType , publicRPC: publicRPC , chainName: chainName  } = await window.picket.chainInfo(selectedChain);
            // if the wallet is ready and a QR code wallet and has onConnecting callback
            if (wallet.ready && wallet.qrCode && !!wallet.onConnecting) {
                // HACK: RainbowKit implements a similar hack
                // keep local variable to prevent multiple calls to the same callback
                let hasCalledCallback = false;
                wallet.onConnecting(async ()=>{
                    // should never happen
                    if (!wallet.qrCodeURI) return;
                    // prevent from calling multiple times
                    if (hasCalledCallback) return;
                    hasCalledCallback = true;
                    const uri = await wallet.qrCodeURI();
                    const mobile = (0, $9f71b8ea7336133a$export$d0a8044dce8ff2fc)();
                    // on desktop display the QR code screen
                    if (!mobile) {
                        setQRCodeURI(uri);
                        return;
                    }
                    // on mobile open the QR code URI
                    // adapted from
                    // https://github.com/rainbow-me/rainbowkit/blob/main/packages/rainbowkit/src/components/ConnectOptions/MobileOptions.tsx#L64
                    // NOTE: This might not work if the modal is in an iFrame (haven't tested)
                    if (uri.startsWith("http")) {
                        // Workaround for https://github.com/rainbow-me/rainbowkit/issues/524.
                        // Using 'window.open' causes issues on iOS in non-Safari browsers and
                        // WebViews where a blank tab is left behind after connecting.
                        // This is especially bad in some WebView scenarios (e.g. following a
                        // link from Twitter) where the user doesn't have any mechanism for
                        // closing the blank tab.
                        // For whatever reason, links with a target of "_blank" don't suffer
                        // from this problem, and programmatically clicking a detached link
                        // element with the same attributes also avoids the issue.
                        const link = document.createElement("a");
                        link.href = uri;
                        link.target = "_blank";
                        link.rel = "noreferrer noopener";
                        link.click();
                        return;
                    }
                    // else navigate navigate to the URI per usual
                    window.location.href = uri;
                });
            }
            // do not deconstruct to avoid duplicate walletAddress variables
            const connectResult = await wallet.connect({
                chainId: chainId
            });
            walletAddress = connectResult.walletAddress;
            const { provider: provider  } = connectResult;
            state = "signature";
            setConnectState(state);
            // clear warning and error state transition
            setWarning(false);
            setError("");
            const domain = window.location.host;
            const uri = window.location.origin;
            const issuedAt = new Date().toISOString();
            const context = {
                domain: domain,
                uri: uri,
                issuedAt: issuedAt,
                chainId: chainId,
                chainType: chainType,
                locale: navigator?.language
            };
            // TODO: Conditional based off Picket availability (refactor to separate library)
            const { nonce: nonce , statement: statement , format: // default to SIWE for backwards compatibility
            format = (0, $81c1b644006d48ec$export$4ae89799dfbe2bff).SIWE  } = await window.picket.nonce({
                walletAddress: walletAddress,
                chain: selectedChain,
                locale: context.locale
            });
            const message = window.Picket.createSigningMessage({
                nonce: nonce,
                statement: statement,
                format: format,
                walletAddress: walletAddress,
                ...context
            });
            // request to change chains
            // only support EVM wallets for now
            if (chainType === (0, $81c1b644006d48ec$export$976d254d94e5d55).ETH) try {
                // @ts-ignore accessing private property for now...
                const p = await wallet.connector.getProvider();
                await (0, $39c3e322ce4471ca$export$84592b93abf12add)({
                    provider: p,
                    chainSlug: chainSlug,
                    chainId: chainId,
                    chainName: chainName,
                    publicRPC: publicRPC
                });
            } catch  {
            // ignore error b/c auth will still work. network switch is for UX
            }
            const signature = await wallet.signMessage(message);
            let result = {
                walletAddress: walletAddress,
                signature: signature,
                context: context,
                chain: selectedChain
            };
            // set displayAddress before doing auth in-case of failure
            setDisplayAddress($0aa6d5c30e08fb02$var$displayWalletAddress(walletAddress));
            if (doAuth) {
                state = "auth";
                setConnectState(state);
                // clear warning and error state transition
                setWarning(false);
                setError("");
                const auth = await window.picket.auth({
                    chain: selectedChain,
                    walletAddress: walletAddress,
                    signature: signature,
                    context: context,
                    requirements: requirements
                });
                setDisplayAddress(auth.user.displayAddress === walletAddress ? $0aa6d5c30e08fb02$var$displayWalletAddress(walletAddress) : auth.user.displayAddress);
                result = {
                    ...result,
                    auth: auth
                };
            }
            // re-select wallet in case it was changed
            setSelectedWallet(wallet);
            setSuccess(true);
            setError("");
            // save provider to window for sharing b/c it isn't serializable
            window.PicketProvider = provider;
            window.postMessage({
                type: (0, $c45c1df1549392fa$export$b710c88c1b6226c7),
                data: result
            });
            // start timer to close the modal
            setTimeout(()=>setIsOpen(false), $0aa6d5c30e08fb02$var$AUTO_CLOSE_MS);
        } catch (err) {
            console.log(err);
            const shouldClearSelectedWallet = !wallet.qrCode;
            const errorMsg = $0aa6d5c30e08fb02$var$getErrorMessage({
                err: err,
                state: state,
                wallet: wallet,
                walletAddress: walletAddress,
                selectedChain: selectedChain,
                requirements: requirements
            });
            // do not un-select wallet on token gating error so we can customize the error screen
            if (shouldClearSelectedWallet && errorMsg !== $0aa6d5c30e08fb02$var$NOT_ENOUGH_TOKENS_ERROR) setSelectedWallet(undefined);
            setError(errorMsg);
        } finally{
            // reset connect state
            setConnectState(null);
            // clear warning and timeout
            setWarning(false);
            clearTimeout(warningTimeoutRef.current);
        }
    };
    const showTokenGateFailureScreen = $0aa6d5c30e08fb02$var$hasTokenOwnershipRequirements(requirements) && error === $0aa6d5c30e08fb02$var$NOT_ENOUGH_TOKENS_ERROR;
    const showQRCodeConnectScreen = selectedWallet?.qrCode && !(0, $9f71b8ea7336133a$export$d0a8044dce8ff2fc)();
    const showBackButton = !success && (showTokenGateFailureScreen || showQRCodeConnectScreen);
    return /*#__PURE__*/ (0, $hgUW1$react).createElement("main", {
        style: {
            // default color to dark gray
            color: "#414552",
            fontFamily: 'Inter,-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
        },
        className: (0, $hgUW1$tw)`fixed top-0 left-0 right-0 z-50 flex h-full w-full flex-col items-center justify-center flex-1${isOpen ? "visible backdrop-blur-sm backdrop-filter" : "invisible"}`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`text=[#414552] relative flex min-h-[600px] w-96 flex-col rounded-xl bg-[#FAFAFA] px-6 pt-4 pb-4 shadow-lg dark:bg-[#040825]`
    }, showBackButton && /*#__PURE__*/ (0, $hgUW1$react).createElement("button", {
        onClick: reset,
        className: (0, $hgUW1$tw)`absolute top-3 left-3`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        className: (0, $hgUW1$tw)`h-8 w-8 rounded-lg bg-white text-gray-400 hover:shadow dark:bg-[#26293B]`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 19.5L8.25 12l7.5-7.5"
    }))), /*#__PURE__*/ (0, $hgUW1$react).createElement("button", {
        onClick: close,
        className: (0, $hgUW1$tw)`absolute top-3 right-3`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $hgUW1$tw)`h-8 w-8 rounded-lg bg-white text-gray-400 hover:shadow dark:bg-[#26293B]`,
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        strokeWidth: 2
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18L18 6M6 6l12 12"
    }))), success ? /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $30dda09b2ef840aa$export$2e2bcd8739ae039), {
        selectedWallet: selectedWallet,
        displayAddress: displayAddress,
        hasTokenOwnershipRequirements: $0aa6d5c30e08fb02$var$hasTokenOwnershipRequirements(requirements)
    }) : showTokenGateFailureScreen ? /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $ff9871898d6c0351$export$2e2bcd8739ae039), {
        chain: selectedChain,
        selectedWallet: selectedWallet,
        displayAddress: displayAddress,
        // only get here when requirements are defined
        requirements: requirements,
        back: reset
    }) : showQRCodeConnectScreen ? /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $60fec0881df8b1a4$export$2e2bcd8739ae039), {
        uri: qrCodeURI,
        selectedWallet: selectedWallet,
        connectState: connectState,
        connect: connect,
        error: error,
        warning: warning,
        darkMode: darkMode
    }) : /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $hgUW1$react).Fragment, null, /*#__PURE__*/ (0, $hgUW1$react).createElement("h1", {
        className: (0, $hgUW1$tw)`mb-6 break-words text-left text-xl font-semibold text-[#414552] dark:text-white`
    }, "Log In With Your Wallet"), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`mb-4 flex flex-row flex-nowrap space-x-4 overflow-x-auto text-sm sm:text-base`,
        id: "_picketWalletOptions"
    }, chainOptions.map(({ slug: slug , name: name  })=>/*#__PURE__*/ (0, $hgUW1$react).createElement("button", {
            key: slug,
            onClick: ()=>switchChains(slug),
            // Use style for underline offset until twind supports Tailwind v3
            style: {
                textUnderlineOffset: "2px",
                outlineStyle: "none"
            },
            className: (0, $hgUW1$tw)`font-bold hover:text-[#5469D4] focus:text-[#5469D4] dark:text-gray-400 dark:hover:text-[#5469D4] dark:focus:text-[#5469D4] ${selectedChain === slug ? "text-[#5469D4] underline underline-offset-2 dark:text-[#5469D4]" : ""}`
        }, name))), warning && connectState !== "auth" && /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`mb-4 rounded-lg bg-yellow-100 p-4`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex-shrink-0`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        className: (0, $hgUW1$tw)`h-5 w-5 text-yellow-400`,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        fillRule: "evenodd",
        d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
        clipRule: "evenodd"
    }))), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`ml-3 text-sm text-yellow-700`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", null, $0aa6d5c30e08fb02$var$getWarningMessage({
        wallet: selectedWallet,
        state: connectState
    })), selectedWallet && /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`mt-2 text-xs`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("p", null, "Don", "'", "t see the request?", " ", /*#__PURE__*/ (0, $hgUW1$react).createElement("button", {
        className: (0, $hgUW1$tw)`underline`,
        onClick: ()=>connect(selectedWallet)
    }, "Try again.")))))), error && /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`mb-4 rounded-lg bg-red-100 p-4`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex-shrink-0`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("svg", {
        className: (0, $hgUW1$tw)`h-5 w-5 text-red-400`,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
        clipRule: "evenodd"
    }))), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`ml-3`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`text-sm text-red-700`
    }, error)))), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex min-h-[350px] flex-1 flex-col space-y-2`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        id: "_picketWallets",
        className: (0, $hgUW1$tw)`flex max-h-[300px] flex-1 flex-col space-y-2 overflow-auto py-2 px-2`
    }, walletList?.map((wallet)=>/*#__PURE__*/ (0, $hgUW1$react).createElement("button", {
            key: wallet.id,
            onClick: ()=>connect(wallet),
            style: {
                outlineOffset: "4px"
            },
            disabled: !!connectState,
            className: (0, $hgUW1$tw)`flex w-full items-center rounded-lg bg-white p-2.5 text-sm font-semibold shadow hover:bg-gray-100 disabled:cursor-not-allowed dark:bg-[#26293B] dark:text-white dark:hover:bg-[#181B2E] sm:text-base ${selectedWallet?.id === wallet.id ? "bg-gray-100" : "disabled:bg-white"}`
        }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
            className: (0, $hgUW1$tw)`mr-8 flex items-center overflow-hidden rounded-lg`
        }, /*#__PURE__*/ (0, $hgUW1$react).createElement(wallet.Icon, null)), selectedWallet?.id === wallet.id ? $0aa6d5c30e08fb02$var$connectStateMessage[connectState || "connect"] : wallet.name))), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex flex-col px-2`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`flex w-full flex-grow flex-col-reverse`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`my-2 flex flex-row items-center font-light text-gray-400`
    }, /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`mr-6 block h-px flex-grow border border-x-0 border-t border-b-0 border-solid border-gray-200`
    }), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`block`
    }, "or"), /*#__PURE__*/ (0, $hgUW1$react).createElement("div", {
        className: (0, $hgUW1$tw)`ml-6 block h-px flex-grow border border-x-0 border-t border-b-0 border-solid border-gray-200`
    }))), /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $f3e1fb0fbc54f4d7$export$2e2bcd8739ae039), {
        mobilePreferredWalletLink: selectedChainOption?.mobilePreferredWalletLink || $0aa6d5c30e08fb02$var$RAINBOW_DOWNLOAD_URL,
        desktopPreferredWalletLink: selectedChainOption?.desktopPreferredWalletLink || $0aa6d5c30e08fb02$var$METAMASK_DOWNLOAD_URL
    }))), /*#__PURE__*/ (0, $hgUW1$react).createElement((0, $8c42fa10a91890af$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, $hgUW1$react).createElement("style", {
        // A hacky way to to inject custom CSS without having to have users import the stylesheet
        dangerouslySetInnerHTML: {
            __html: `
  #_picketWalletOptions::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 0px;
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }
  #_picketWallets::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 0px;
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }`
        }
    }));
};
var $0aa6d5c30e08fb02$export$2e2bcd8739ae039 = $0aa6d5c30e08fb02$var$ConnectModal;




const $be93e1682fc4190d$var$mount = async (props)=>{
    //  only mount once
    if (document.getElementById((0, $c45c1df1549392fa$export$ebdd5a8e5b1c2de5))) return;
    //  setup tailwind
    (0, $hgUW1$setup)((0, $f54f8f1219a67c28$export$2e2bcd8739ae039));
    const el = document.createElement("div");
    el.id = (0, $c45c1df1549392fa$export$ebdd5a8e5b1c2de5);
    document.body.appendChild(el);
    const container = document.getElementById((0, $c45c1df1549392fa$export$ebdd5a8e5b1c2de5));
    // This try/catch always fails because of
    // https://github.com/parcel-bundler/parcel/issues/7268
    try {
        // React 18
        const { createRoot: createRoot  } = await $be93e1682fc4190d$importAsync$fe6d780185957fb2;
        const root = createRoot(container);
        root.render(/*#__PURE__*/ (0, $hgUW1$react).createElement((0, $0aa6d5c30e08fb02$export$2e2bcd8739ae039), props));
    } catch (err) {
        // React <18
        (0, $hgUW1$render)(/*#__PURE__*/ (0, $hgUW1$react).createElement((0, $0aa6d5c30e08fb02$export$2e2bcd8739ae039), props), container);
    }
};
const $be93e1682fc4190d$export$64605811ab45167f = (props)=>new Promise((resolve, reject)=>{
        //  make sure the modal is mounted
        $be93e1682fc4190d$var$mount(props).then(()=>{
            //  make sure the modal is open
            window.postMessage({
                type: (0, $c45c1df1549392fa$export$c3ae8fcace251182),
                data: props
            });
            //  wait for close or connect
            window.addEventListener("message", (event)=>{
                if (!event.data?.type) return;
                const { type: type , data: data  } = event.data;
                if (type === (0, $c45c1df1549392fa$export$efac531f51245c0f)) return reject("Modal closed");
                // pass data
                if (type === (0, $c45c1df1549392fa$export$b710c88c1b6226c7)) {
                    // cannot serialize provider, pass through window object
                    const provider = window.PicketProvider;
                    resolve({
                        ...data,
                        provider: provider
                    });
                }
            });
        });
    });


var $4dd92028ea23726e$exports = {};

$parcel$export($4dd92028ea23726e$exports, "randomState", () => $4dd92028ea23726e$export$ef959a27a958b03b);
$parcel$export($4dd92028ea23726e$exports, "hasAuthorizationCodeParams", () => $4dd92028ea23726e$export$4a8d32a6e81d85f8);
$parcel$export($4dd92028ea23726e$exports, "parseAuthorizationCodeParams", () => $4dd92028ea23726e$export$efa54f2ecf842e67);
$parcel$export($4dd92028ea23726e$exports, "defaultLoginRedirectCallback", () => $4dd92028ea23726e$export$579314b3a4d5cc11);
// Adapted from https://github.com/auth0/auth0-spa-js/blob/master/src/utils.ts#L143
const $54715df8f1401dad$export$9d01343f306f889d = ()=>{
    //safari 10.x uses webkitSubtle
    return window.crypto.subtle || window.crypto.webkitSubtle;
};
const $54715df8f1401dad$export$7fa8378418b4411e = ()=>{
    const charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let random = "";
    const randomValues = Array.from(window.crypto.getRandomValues(new Uint8Array(43)));
    randomValues.forEach((v)=>random += charset[v % charset.length]);
    return random;
};


const $4dd92028ea23726e$export$ef959a27a958b03b = ()=>btoa((0, $54715df8f1401dad$export$7fa8378418b4411e)());
const $4dd92028ea23726e$export$4a8d32a6e81d85f8 = (url)=>{
    const { searchParams: searchParams  } = new URL(url);
    // state is required
    // check for either error param OR code
    return searchParams.has("state") && (searchParams.has("code") || searchParams.has("error"));
};
const $4dd92028ea23726e$export$efa54f2ecf842e67 = (url)=>{
    const { searchParams: searchParams  } = new URL(url);
    if (!$4dd92028ea23726e$export$4a8d32a6e81d85f8(url)) throw new Error("there are no authorization code params to parse");
    // validate expected parameters exists
    return {
        state: searchParams.get("state"),
        code: searchParams.get("code"),
        error: searchParams.get("error"),
        error_description: searchParams.get("error_description")
    };
};
const $4dd92028ea23726e$export$579314b3a4d5cc11 = (appState)=>window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);


// Adapted from: https://github.com/auth0/auth0-spa-js/blob/0ae6078c02d3a4184147e788adfceae4db78db65/src/utils.ts#L89
const $40126bfb5d1a8030$var$POPUP_WIDTH = 400;
const $40126bfb5d1a8030$var$POPUP_HEIGHT = 400;
const $40126bfb5d1a8030$export$3ce6949f20cea765 = (url)=>{
    // center the popup
    const left = window.screenX + (window.innerWidth - $40126bfb5d1a8030$var$POPUP_WIDTH) / 2;
    const top = window.screenY + (window.innerHeight - $40126bfb5d1a8030$var$POPUP_HEIGHT) / 2;
    return window.open(url, "picket:authorize:popup", `left=${left},top=${top},width=${$40126bfb5d1a8030$var$POPUP_WIDTH},height=${$40126bfb5d1a8030$var$POPUP_HEIGHT},resizable,scrollbars=yes,status=1`);
};
const $40126bfb5d1a8030$var$ONE_SECOND_IN_MILLISECONDS = 1000;
const $40126bfb5d1a8030$var$TIMEOUT_IN_SECONDS = 120;
const $40126bfb5d1a8030$export$889ea624f2cb2c57 = (popup)=>{
    return new Promise((resolve, reject)=>{
        // @ts-ignore MessageEvent implements Event per docs. Unclear why TS complains
        const popupEventListener = function(e) {
            if (!e.isTrusted) return;
            // verify the message came from the authorization server
            if (e.origin !== popup.origin) return;
            const { data: data  } = e;
            if (!data || data.type !== "authorization_response") return;
            const { response: response  } = data;
            // we expect a response...
            if (!response) return;
            clearTimeout(timeoutId);
            clearInterval(popupTimer);
            window.removeEventListener("message", popupEventListener, false);
            popup.close();
            const { error: error , error_description: error_description  } = response;
            if (error) return reject(new Error(error_description || error));
            resolve(response);
        };
        // Check each second if the popup is closed triggering a PopupCancelledError
        const popupTimer = setInterval(()=>{
            if (popup && popup.closed) {
                clearInterval(popupTimer);
                clearTimeout(timeoutId);
                window.removeEventListener("message", popupEventListener, false);
                reject(new Error("popup closed"));
            }
        }, $40126bfb5d1a8030$var$ONE_SECOND_IN_MILLISECONDS);
        const timeoutId = setTimeout(()=>{
            clearInterval(popupTimer);
            reject(new Error("popup timed out"));
            window.removeEventListener("message", popupEventListener, false);
        }, $40126bfb5d1a8030$var$TIMEOUT_IN_SECONDS * $40126bfb5d1a8030$var$ONE_SECOND_IN_MILLISECONDS);
        window.addEventListener("message", popupEventListener);
    });
};



const $4701dd2857dc78df$var$DEFAULT_LOCALE = "en";
const $4701dd2857dc78df$export$2faeed762aac6741 = "light";
const $4701dd2857dc78df$export$24a86ef7798177e4 = "v1";
const $4701dd2857dc78df$var$BASE_API_URL = `https://picketapi.com/api/${$4701dd2857dc78df$export$24a86ef7798177e4}`;
// Consider migrating to cookies https://github.com/auth0/auth0.js/pull/817
const $4701dd2857dc78df$var$LOCAL_STORAGE_KEY = "_picketauth";
const $4701dd2857dc78df$var$PKCE_STORAGE_KEY = `${$4701dd2857dc78df$var$LOCAL_STORAGE_KEY}_pkce`;
const $4701dd2857dc78df$var$isSuccessfulStatusCode = (status)=>status >= 200 && status < 300;
// If b is 0, then it checks if a is positive
// If b is non-zero, then check for greater than or equal to
const $4701dd2857dc78df$var$isGreaterThanOrEqualToOrNonZero = (a, b)=>{
    if (b.isZero()) // use isGreaterThan because isPositive returns true for 0
    return a.isGreaterThan(0);
    return a.isGreaterThanOrEqualTo(b);
};
class $4701dd2857dc78df$export$a9ae479f2e698b14 {
    baseURL = $4701dd2857dc78df$var$BASE_API_URL;
    theme = $4701dd2857dc78df$export$2faeed762aac6741;
    #apiKey;
    #authState;
    #chainCache = {};
    #isAuthorizing = false;
    constructor(apiKey, { baseURL: baseURL = $4701dd2857dc78df$var$BASE_API_URL , theme: theme = $4701dd2857dc78df$export$2faeed762aac6741  } = {}){
        if (!apiKey) throw new Error("Missing publishable API Key");
        this.#apiKey = apiKey;
        this.baseURL = baseURL;
        this.theme = theme;
        if (typeof window !== "undefined") window.picket = this;
    }
    #defaultHeaders = ()=>({
            "Content-Type": "application/json",
            Authorization: `Basic  ${btoa(this.#apiKey)}`
        });
    // -------------
    // API SDK
    // -------------
    /**
   * nonce
   * Function for retrieving nonce for a given user
   */ async nonce({ walletAddress: walletAddress , chain: chain = (0, $81c1b644006d48ec$export$976d254d94e5d55).ETH , locale: // default to English
    locale = $4701dd2857dc78df$var$DEFAULT_LOCALE  }) {
        const url = `${this.baseURL}/auth/nonce`;
        const res = await fetch(url, {
            method: "POST",
            headers: this.#defaultHeaders(),
            body: JSON.stringify({
                chain: chain,
                walletAddress: walletAddress,
                locale: locale
            })
        });
        const data = await res.json();
        // Reject non-successful responses
        if (!$4701dd2857dc78df$var$isSuccessfulStatusCode(res.status)) return Promise.reject(data);
        return data;
    }
    /**
   * auth
   * Function for initiating auth / token gating
   */ async auth({ chain: chain = (0, $81c1b644006d48ec$export$976d254d94e5d55).ETH , walletAddress: walletAddress , signature: signature , requirements: requirements , context: context  }) {
        if (!walletAddress) throw new Error("walletAddress parameter is required - see docs for reference.");
        if (!signature) throw new Error("signature parameter is required - see docs for reference.");
        const url = `${this.baseURL}/auth`;
        const reqOptions = {
            method: "POST",
            headers: this.#defaultHeaders(),
            body: JSON.stringify({
                chain: chain,
                walletAddress: walletAddress,
                signature: signature,
                requirements: requirements,
                context: context
            })
        };
        const res = await fetch(url, reqOptions);
        const data = await res.json();
        // Reject non-successful responses
        if (!$4701dd2857dc78df$var$isSuccessfulStatusCode(res.status)) return Promise.reject(data);
        window.localStorage.setItem($4701dd2857dc78df$var$LOCAL_STORAGE_KEY, JSON.stringify(data));
        this.#authState = data;
        return data;
    }
    /**
   * authz
   * Function for checking if a given user is authorized (aka meets the requirements)
   */ async authz({ accessToken: accessToken , requirements: requirements , revalidate: revalidate = false  }) {
        if (!accessToken) throw new Error("accessToken parameter is required - see docs for reference.");
        if (!requirements) throw new Error("requirements parameter is required - see docs for reference.");
        if (this.#isAuthorizing) console.warn("Already authorizing. Concurrent authorization requests are not supported yet and may cause unexpected behavior.");
        // TODO: Add request queue to ensure only one request is made at a time
        // Temporary flag for warning developers
        this.#isAuthorizing = true;
        const url = `${this.baseURL}/authz`;
        const reqOptions = {
            method: "POST",
            headers: this.#defaultHeaders(),
            body: JSON.stringify({
                accessToken: accessToken,
                requirements: requirements,
                revalidate: revalidate
            })
        };
        const res = await fetch(url, reqOptions);
        const data = await res.json();
        // Reject non-successful responses
        if (!$4701dd2857dc78df$var$isSuccessfulStatusCode(res.status)) {
            this.#isAuthorizing = false;
            return Promise.reject(data);
        }
        // on success update auth state
        window.localStorage.setItem($4701dd2857dc78df$var$LOCAL_STORAGE_KEY, JSON.stringify(data));
        this.#authState = data;
        this.#isAuthorizing = false;
        return data;
    }
    /**
   * Validate
   * Validate the given access token and requirements
   */ async validate(accessToken, requirements) {
        if (!accessToken) return Promise.reject({
            msg: "access token is empty"
        });
        const url = `${this.baseURL}/auth/validate`;
        const res = await fetch(url, {
            method: "POST",
            headers: this.#defaultHeaders(),
            body: JSON.stringify({
                accessToken: accessToken,
                requirements: requirements
            })
        });
        const data = await res.json();
        // Reject non-successful responses
        if (!$4701dd2857dc78df$var$isSuccessfulStatusCode(res.status)) return Promise.reject(data);
        return data;
    }
    /**
   * chainInfo
   * Function for retrieving chain information
   */ async chainInfo(chain) {
        if (this.#chainCache[chain]) return this.#chainCache[chain];
        const url = `${this.baseURL}/chains/${chain}`;
        const res = await fetch(url, {
            method: "GET",
            headers: this.#defaultHeaders()
        });
        const data = await res.json();
        // Reject non-successful responses
        if (!$4701dd2857dc78df$var$isSuccessfulStatusCode(res.status)) return Promise.reject(data);
        // save to cache
        this.#chainCache[chain] = data;
        return data;
    }
    /**
   * chains
   * Function for retrieving information on supported chains
   */ async chains() {
        const url = `${this.baseURL}/chains`;
        const res = await fetch(url, {
            method: "GET",
            headers: this.#defaultHeaders()
        });
        const data = await res.json();
        // reject any error code > 201
        if (!$4701dd2857dc78df$var$isSuccessfulStatusCode(res.status)) return Promise.reject(data);
        // save to cache
        for (const chain of data.data)this.#chainCache[chain.chainSlug] = chain;
        return data.data;
    }
    // -----------
    // Client-side SDK Utilities
    // -----------
    /**
   * login
   * Login with your wallet, and optionally, specify login requirements
   */ async login(req) {
        return await this.loginWithTrustedWalletProivder(req);
    }
    /**
   * loginWithTrustedWalletProivder
   * Login with a trusted wallet provider that supports Sign-In With Ethereum (EIP-4361) or similar standard
   */ async loginWithTrustedWalletProivder({ chain: chain , walletAddress: walletAddress , signature: signature , context: context , ...requirements } = {}) {
        // 1. If no signature provided, connect to local provider and get signature
        if (!(walletAddress && signature)) {
            const { auth: auth , ...info } = await this.connect({
                chain: chain,
                doAuth: true,
                requirements: requirements
            });
            if (auth) return auth;
            walletAddress = info.walletAddress;
            signature = info.signature;
            context = info.context;
            chain = info.chain;
        }
        // 2. Exchange signature for access token
        return await this.auth({
            chain: chain || (0, $81c1b644006d48ec$export$976d254d94e5d55).ETH,
            walletAddress: walletAddress,
            signature: signature,
            context: context,
            requirements: requirements
        });
    }
    /**
   * getAuthorizationURL
   * getAuthorizationURL returns the authorization URL for the PKCE authorization parameters.
   */ getAuthorizationURL({ chain: chain , walletAddress: walletAddress , signature: signature , contractAddress: contractAddress , tokenIds: tokenIds , collection: collection , creatorAddress: creatorAddress , minTokenBalance: minTokenBalance , allowedWallets: allowedWallets , redirectURI: redirectURI , codeChallenge: codeChallenge , state: state , responseMode: responseMode , locale: locale = $4701dd2857dc78df$var$DEFAULT_LOCALE  }) {
        const url = new URL(`${this.baseURL}/oauth2/authorize`);
        url.searchParams.set("client_id", this.#apiKey);
        url.searchParams.set("redirect_uri", redirectURI);
        url.searchParams.set("code_challenge", codeChallenge);
        url.searchParams.set("state", state);
        url.searchParams.set("code_challenge_method", "S256");
        url.searchParams.set("response_mode", responseMode);
        url.searchParams.set("locale", locale);
        chain && url.searchParams.set("chain", chain);
        walletAddress && url.searchParams.set("walletAddress", walletAddress);
        signature && url.searchParams.set("signature", signature);
        contractAddress && url.searchParams.set("contractAddress", contractAddress);
        minTokenBalance && url.searchParams.set("minTokenBalance", String(minTokenBalance));
        // START: Solana-specific
        if (collection) {
            const collections = Array.isArray(collection) ? collection : [
                collection
            ];
            for (const c of collections)url.searchParams.append("collection", c);
        }
        creatorAddress && url.searchParams.set("creatorAddress", creatorAddress);
        if (tokenIds) for (let id of tokenIds)url.searchParams.append("tokenIds", id);
        // END: Solana-specific
        if (allowedWallets) for (let address of allowedWallets)url.searchParams.append("allowedWallets", address);
        return url.toString();
    }
    /**
   * loginWithRedirect
   * loginWithRedirect starts the OAuth2.0 PKCE flow
   */ async loginWithRedirect({ chain: chain = (0, $81c1b644006d48ec$export$976d254d94e5d55).ETH , walletAddress: walletAddress , signature: signature , tokenIds: tokenIds , contractAddress: contractAddress , minTokenBalance: minTokenBalance , allowedWallets: allowedWallets  } = {}, { redirectURI: redirectURI = window.location.href , appState: appState = {}  } = {
        redirectURI: window.location.href,
        appState: {}
    }) {
        // 1. If no signature provided, connect to local provider and get signature
        if (!(walletAddress && signature)) {
            const info = await this.connect({
                chain: chain
            });
            walletAddress = info.walletAddress;
            signature = info.signature;
        }
        const state = (0, $4dd92028ea23726e$export$ef959a27a958b03b)();
        // 2. generate PKCE and store!
        const { code_challenge: code_challenge , code_verifier: code_verifier  } = (0, $hgUW1$pkcechallenge)();
        window.localStorage.setItem($4701dd2857dc78df$var$PKCE_STORAGE_KEY, JSON.stringify({
            code_verifier: code_verifier,
            state: state,
            appState: appState,
            redirectURI: redirectURI
        }));
        // 3. get authorization URL
        const authorizationURL = this.getAuthorizationURL({
            chain: chain,
            walletAddress: walletAddress,
            signature: signature,
            contractAddress: contractAddress,
            tokenIds: tokenIds,
            minTokenBalance: minTokenBalance,
            allowedWallets: allowedWallets,
            redirectURI: redirectURI,
            state: state,
            codeChallenge: code_challenge,
            responseMode: "code"
        });
        // 4. redirect user
        window.location.assign(authorizationURL);
    }
    /**
   * oauth2AuthorizationCodeToken
   * oauth2AuthorizationCodeToken implements the final step of the OAuth2.0 PKCE flow and exchanges an authorization code for an access token.
   */ async oauth2AuthorizationCodeToken({ code: code , codeVerifier: codeVerifier , redirectURI: redirectURI  }) {
        // get the token!
        const res = await fetch(`${this.baseURL}/oauth2/token`, {
            method: "POST",
            headers: this.#defaultHeaders(),
            body: JSON.stringify({
                grant_type: "authorization_code",
                code_verifier: codeVerifier,
                code: code,
                redirect_uri: redirectURI
            })
        });
        const data = await res.json();
        // reject any error code > 201
        if (!$4701dd2857dc78df$var$isSuccessfulStatusCode(res.status)) return Promise.reject(data);
        // save it locally!
        window.localStorage.setItem($4701dd2857dc78df$var$LOCAL_STORAGE_KEY, JSON.stringify(data));
        this.#authState = data;
        return data;
    }
    /**
   * handleLoginRedirect
   * handleLoginRedirect fetches an access token after a successful authorization redirect.
   * If there are no authorization code query parameters or there are error query parameters, it will raise an error.
   */ async handleLoginRedirect(url = window.location.href) {
        const { code: code , state: state , error: error , error_description: error_description  } = (0, $4dd92028ea23726e$export$efa54f2ecf842e67)(url);
        if (error) // OAuth 2.0 specifies at least error must be defined
        throw new Error(error_description || error);
        if (!code) throw new Error("no authorization code in query");
        const transaction = window.localStorage.getItem($4701dd2857dc78df$var$PKCE_STORAGE_KEY);
        if (!transaction) throw new Error("invalid state. missing pkce transaction data.");
        const { code_verifier: code_verifier , state: storedState , redirectURI: redirectURI , appState: appState  } = JSON.parse(transaction);
        if (!code_verifier) throw new Error("invalid state. code_verifier is missing in pkce transaction data");
        if (storedState !== state) throw new Error("invalid state. stored state doesn't match query parameter state ");
        const auth = await this.oauth2AuthorizationCodeToken({
            code: code,
            codeVerifier: code_verifier,
            redirectURI: redirectURI
        });
        // clear PKCE transaction from storage
        window.localStorage.removeItem($4701dd2857dc78df$var$PKCE_STORAGE_KEY);
        return {
            ...auth,
            appState: appState
        };
    }
    /**
   * loginWithPopup
   * loginWithPopup starts the OAuth2.0 PKCE flow
   *
   * Implements https://datatracker.ietf.org/doc/html/draft-sakimura-oauth-wmrm-00#section-2.3
   */ async loginWithPopup({ chain: chain = (0, $81c1b644006d48ec$export$976d254d94e5d55).ETH , walletAddress: walletAddress , signature: signature , contractAddress: contractAddress , tokenIds: tokenIds , minTokenBalance: minTokenBalance , allowedWallets: allowedWallets  } = {}, { redirectURI: redirectURI = window.location.href  } = {
        redirectURI: window.location.href
    }) {
        // 1. If no signature provided, connect to local provider and get signature
        if (!(walletAddress && signature)) {
            const info = await this.connect({
                chain: chain
            });
            walletAddress = info.walletAddress;
            signature = info.signature;
        }
        const state = (0, $4dd92028ea23726e$export$ef959a27a958b03b)();
        // 2. generate PKCE and store!
        const { code_challenge: code_challenge , code_verifier: code_verifier  } = (0, $hgUW1$pkcechallenge)();
        // 3. get authorization URL
        const authorizationURL = this.getAuthorizationURL({
            chain: chain,
            walletAddress: walletAddress,
            signature: signature,
            contractAddress: contractAddress,
            tokenIds: tokenIds,
            minTokenBalance: minTokenBalance,
            allowedWallets: allowedWallets,
            state: state,
            codeChallenge: code_challenge,
            redirectURI: redirectURI,
            responseMode: "web_message"
        });
        // 4. Open popup
        let authorizationPopup = $40126bfb5d1a8030$export$3ce6949f20cea765(authorizationURL);
        // try see if the popup has been blocked
        if (!authorizationPopup || authorizationPopup.closed || typeof authorizationPopup.closed === "undefined") throw new Error("failed to open popup");
        const res = await $40126bfb5d1a8030$export$889ea624f2cb2c57(authorizationPopup);
        if (res.error) // OAuth 2.0 specifies at least error must be defined
        throw new Error(res.error_description || res.error);
        if (!res.code) throw new Error("no authorization code returned from popup");
        if (res.state !== state) throw new Error("invalid state. stored state doesn't match query parameter state ");
        const auth = await this.oauth2AuthorizationCodeToken({
            code: res.code,
            codeVerifier: code_verifier,
            redirectURI: redirectURI
        });
        return auth;
    }
    static createSigningMessage(args) {
        const { format: format = (0, $81c1b644006d48ec$export$4ae89799dfbe2bff).SIMPLE  } = args;
        if (format === (0, $81c1b644006d48ec$export$4ae89799dfbe2bff).SIMPLE) {
            const { statement: statement , walletAddress: walletAddress , nonce: nonce  } = args;
            return `${statement}\n\nAddress: ${walletAddress}\nNonce: ${nonce}`;
        }
        const { statement: statement , walletAddress: walletAddress , nonce: nonce , domain: domain , uri: uri , issuedAt: issuedAt , chainId: chainId , chainType: chainType  } = args;
        const message = new (0, $hgUW1$SiweMessage)({
            address: walletAddress,
            nonce: nonce,
            statement: statement,
            domain: domain,
            uri: uri,
            chainId: chainId,
            issuedAt: issuedAt,
            version: "1"
        });
        let signingMessage = message.prepareMessage();
        if (chainType === (0, $81c1b644006d48ec$export$976d254d94e5d55).SOL) // Solana doesn't use the SIWE standard, so modifying the message is OK
        signingMessage = signingMessage.replaceAll("Ethereum", "Solana");
        if (chainType === (0, $81c1b644006d48ec$export$976d254d94e5d55).FLOW) // Flow doesn't use the SIWE standard, so modifying the message is OK
        signingMessage = signingMessage.replaceAll("Ethereum", "Flow");
        return signingMessage;
    }
    /**
   * connect
   * Convenience function to connect wallet and sign nonce, prompts user to connect wallet and returns wallet object
   */ async connect({ chain: chain , doAuth: doAuth = false , requirements: requirements  }) {
        return await (0, $be93e1682fc4190d$export$64605811ab45167f)({
            chain: chain,
            doAuth: doAuth,
            requirements: requirements,
            theme: this.theme
        });
    }
    /**
   * logout
   * Clears authentication information
   */ async logout() {
        this.#authState = undefined;
        window.localStorage.removeItem($4701dd2857dc78df$var$LOCAL_STORAGE_KEY);
        // clear wallet connect session on logout
        window.localStorage.removeItem("-walletlink:https://www.walletlink.org:version");
        window.localStorage.removeItem("-walletlink:https://www.walletlink.org:session:id");
        window.localStorage.removeItem("-walletlink:https://www.walletlink.org:session:secret");
        window.localStorage.removeItem("-walletlink:https://www.walletlink.org:session:linked");
        window.localStorage.removeItem("walletconnect");
        return Promise.resolve();
    }
    /**
   * authState
   * get user auth information if it exists
   */ async authState() {
        // check memory
        // check state
        if (this.#authState) return this.#authState;
        const stored = window.localStorage.getItem($4701dd2857dc78df$var$LOCAL_STORAGE_KEY);
        if (!stored) return Promise.resolve(null);
        const authState = JSON.parse(stored);
        // validate the accessToken on the ad
        try {
            await this.validate(authState.accessToken);
        } catch (err) {
            console.log("deleting invalid access token:", err);
            await this.logout();
            return Promise.resolve(null);
        }
        this.#authState = authState;
        return Promise.resolve(authState);
    }
    /**
   * isCurrentUserAuthorized
   * Does the current user authorized given the requirements?
   */ async isCurrentUserAuthorized({ requirements: requirements , revalidate: revalidate = false  }) {
        const authState = await this.authState();
        // TODO: Is it better to error? prompt login? for logged out users
        if (!authState) return false;
        const { accessToken: accessToken , user: user  } = authState;
        // first check local user balance before hitting API
        if (!revalidate) {
            const allowed = $4701dd2857dc78df$export$a9ae479f2e698b14.meetsAuthRequirements({
                user: user,
                requirements: requirements
            });
            if (allowed) return true;
        }
        try {
            await this.authz({
                accessToken: accessToken,
                requirements: requirements,
                revalidate: revalidate
            });
            return true;
        } catch (err) {
            console.warn("user is not authorized", err);
            return false;
        }
    }
    /**
   * meetsAuthRequirements
   * Does the given user meet the authorization requirements?
   * Synchronous, helper function for users to check easily if the user meets the auth requirements.
   * Example usage is for setting "disabled" property on a button.
   */ static meetsAuthRequirements({ user: user , requirements: requirements  }) {
        if (!user) return false;
        // no requirements (shouldn't happen, but let's handle)
        if (!requirements || Object.keys(requirements).length === 0) return true;
        const { tokenBalances: tokenBalances  } = user;
        if (!tokenBalances || Object.keys(tokenBalances).length === 0) return false;
        const minTokenBalance = new (0, $hgUW1$bignumberjs)(requirements.minTokenBalance || 0);
        let totalBalance = new (0, $hgUW1$bignumberjs)(0);
        // EVM
        if (requirements.contractAddress && tokenBalances.contractAddress) {
            const { contractAddress: contractAddress  } = requirements;
            const balance = tokenBalances.contractAddress[contractAddress];
            if (balance) totalBalance = totalBalance.plus(balance);
            const allowed = $4701dd2857dc78df$var$isGreaterThanOrEqualToOrNonZero(totalBalance, minTokenBalance);
            if (allowed) return true;
        }
        // Solana
        const { collection: collection , tokenIds: tokenIds , creatorAddress: creatorAddress  } = requirements;
        if (collection && tokenBalances.collection) {
            const collections = Array.isArray(collection) ? collection : [
                collection
            ];
            for (const c of collections){
                const balance = tokenBalances.collection[c];
                if (balance) totalBalance = totalBalance.plus(balance);
                const allowed = $4701dd2857dc78df$var$isGreaterThanOrEqualToOrNonZero(totalBalance, minTokenBalance);
                if (allowed) return true;
            }
        }
        if (creatorAddress && tokenBalances.creatorAddress) {
            const balance = tokenBalances.creatorAddress[creatorAddress];
            if (balance) totalBalance = totalBalance.plus(balance);
            const allowed = $4701dd2857dc78df$var$isGreaterThanOrEqualToOrNonZero(totalBalance, minTokenBalance);
            if (allowed) return true;
        }
        if (tokenIds && tokenIds.length > 0 && tokenBalances.tokenIds) for (let tokenId of tokenIds){
            const balance = tokenBalances.tokenIds[tokenId];
            if (!balance) continue;
            totalBalance = totalBalance.plus(balance);
            const allowed = $4701dd2857dc78df$var$isGreaterThanOrEqualToOrNonZero(totalBalance, minTokenBalance);
            if (allowed) return true;
        }
        return $4701dd2857dc78df$var$isGreaterThanOrEqualToOrNonZero(totalBalance, minTokenBalance);
    }
}
var $4701dd2857dc78df$export$2e2bcd8739ae039 = $4701dd2857dc78df$export$a9ae479f2e698b14;




// make available to browser
if (typeof window !== "undefined") window.Picket = (0, $4701dd2857dc78df$export$2e2bcd8739ae039);
var $149c1bd638913645$export$2e2bcd8739ae039 = (0, $4701dd2857dc78df$export$2e2bcd8739ae039);


export {$149c1bd638913645$export$2e2bcd8739ae039 as default, $81c1b644006d48ec$export$976d254d94e5d55 as ChainTypes, $81c1b644006d48ec$export$4ae89799dfbe2bff as SigningMessageFormat, $4701dd2857dc78df$export$2faeed762aac6741 as DEFAULT_THEME, $4701dd2857dc78df$export$24a86ef7798177e4 as API_VERSION, $4701dd2857dc78df$export$a9ae479f2e698b14 as Picket, $4dd92028ea23726e$export$ef959a27a958b03b as randomState, $4dd92028ea23726e$export$4a8d32a6e81d85f8 as hasAuthorizationCodeParams, $4dd92028ea23726e$export$efa54f2ecf842e67 as parseAuthorizationCodeParams, $4dd92028ea23726e$export$579314b3a4d5cc11 as defaultLoginRedirectCallback};
//# sourceMappingURL=index.mjs.map
